import React, { Component } from "react";
import { Link, NavLink, withRouter } from "react-router-dom";
import Input from "../components/InputControls/Input/Input.jsx";
import { Image as CloudinaryImage, Transformation } from "cloudinary-react";
import axios from "../services";
import { connect } from "react-redux";
import * as actions from "../actions";
import Modal from "../components/Modal/Modal.jsx";
import ConformationModal from "../components/ConformationModal/ConformationModal.jsx";
import ProfileMediaModal from "../components/ProfileMediaModal/ProfileMediaModal.jsx";
import VotingTicketModal from "../components/VotingTicketModal/VotingTicketModal.jsx";
import ReportModal from "../components/ReportModal/ReportModal.jsx";
import { StickyFunction } from "../js/custom.js";
import Loader from "../components/Loader/Loader.js";
import VoterInfoModal from "../components/VoterInfoModal/VoterInfoModal.jsx";
import { cloudName } from "../constants/constants";
import moment from "moment";
import InfiniteScroll from "react-infinite-scroll-component";
// import AdSense from 'react-adsense';
// import Image from '../../../components/Image/Image.jsx';
import Image from "../components/Image/Image.jsx";
import SocialShareModal from "../components/SocialShareModal/SocialShareModal.jsx";
import { timerUpload } from "../utils/timer.js";
import ImageCropModal from "../components/ImageCropModal/ImageCropModal.jsx";

class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMobileSidebar: false,
      showFilter: false
    };
  }
  componentWillMount() {
    timerUpload();
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    (window.adsbygoogle = window.adsbygoogle || []).push({});
    this.props.getUser();
    this.props.getNotificationList(0);
    let user = JSON.parse(localStorage.getItem("userData"));
    this.props.getFilterListData();
    if (!user) {
      this.props.path.push("/login");
    } else {
      if (user.isVerify == false) {
        this.props.path.push("/phone-verification");
      } else if (user.email == undefined) {
        this.props.path.push("/signup-profile");
      }
    }
    if (this.props.redirectURL != "") {
      this.props.changeRedirectURL();
    }
    StickyFunction();
  }
  fetchMoreData = () => {
    let { notifications } = this.props;
    this.props.getNotificationList(notifications.list.length);
  };

  notificationRedirect = (payload, index) => {
    if (payload.isRead == false) {
      this.props.notificationMarkAsRead({ id: payload._id, index });
    }

    switch (payload.notificationType) {
      case "DAILY_TICKETS":
        this.props.path.push(`/voting-tickets`);
        break;
      case "GOT_VOTE":
        this.props.path.push(`/contest-profile/${payload.contestName}`);
        break;
      case "MEDIA_ACCEPTED":
        this.props.path.push(`/contest-profile/${payload.contestName}`);
        break;
      case "CONTEST_WINNER":
        this.props.path.push(`/contest-detail/${payload.contestName}`);
        break;
      case "FEATURED_VIDEO":
        this.props.path.push(`/contest-profile/${payload.contestName}`);
        break;
      case "HOST_STATUS_APPROVED":
        this.props.path.push(`/judge-profile/${payload.contestName}`);
        break;
      case "CONTEST_CREATE":
        this.props.path.push(`/contest-detail/${payload.contestName}`);
        break;
      case "ADD_POST":
        this.props.path.push(
          `/${payload.contestName}/media/${
            payload.mediaId
          }/${encodeURIComponent(payload.userId)}`
        );
        break;
      case "CONTEST_WINNER_PUSH":
        // this.props.resetContestProfile();
        this.props.getUserContestProfileData({
          ID: payload.contestName,
          userID: encodeURIComponent(payload.userId)
        });
        this.props.getEnrolledContests();
        this.props.path.push(
          `/contest-detail/${encodeURIComponent(payload.contestName)}`
        );
        break;
    }
  };

  reportedFunction = e => {
    e.innerHTML = "Reported";
  };

  handleKeyPress = e => {
    if (e.keyCode == 27) {
      this.props.modalClose();
      this.props.conformationModalClose();
      this.props.profileMediaModalClose();
      this.props.votingTicketModalClose();
      this.props.socialShareModalClose();
      this.props.voterInfoModalClose();
      this.props.reportModalClose();
    }
  };
  render() {
    const { showMobileSidebar, showFilter } = this.state;
    const {
      filterContestList,
      loader,
      label,
      open,
      voteOpen,
      shareOpen,
      conformationOpen,
      reportOpen,
      userData,
      notifications,
      hasMore
    } = this.props;

    const pathname = this.props.path.location.pathname;
    const { tickets } = userData;
    const ticketCount = tickets.regular + tickets.platinum + tickets.gold;
    (function() {
      const token = localStorage.getItem("token");
      if (token) {
        axios.defaults.headers.common.Authorization = token;
      } else {
        axios.defaults.headers.common.Authorization = null;
      }
    })();
    return (
      <React.Fragment>
        {loader ? <Loader label={label} /> : null}
        <Modal />
        <ConformationModal />
        <ProfileMediaModal />
        <VotingTicketModal />
        <SocialShareModal />
        <VoterInfoModal />
        <ImageCropModal />
        <ReportModal checkReport={this.reportedFunction} />
        <div
          className={
            loader ||
            open ||
            voteOpen ||
            shareOpen ||
            conformationOpen ||
            reportOpen
              ? "blurin"
              : ""
          }
        >
          <div
            className={
              pathname.length == 1 || pathname.includes("explore")
                ? ""
                : "innerpages"
            }
            onKeyDown={e => this.handleKeyPress(e)}
            tabIndex="0"
          >
            <nav className="navbar fixed-top navbar-light bg-light pl-0 pr-0 navbar-desktop">
              <div className="container">
                <div className="col pl-0 pr-0">
                  <Link to="/" className="logo">
                    <img
                      src={require("../img/contestee-logo-big.svg")}
                      alt="Contestee Logo"
                    />
                  </Link>
                </div>
                <div
                  className="col pl-0 pr-0 d-flex align-items-center justify-content-center"
                  style={{ zIndex: "1" }}
                >
                  <div className="searchbox">
                    <Link to="/search">
                      <form className="form-group">
                        <Input
                          name=""
                          placeholder="Search"
                          onChange={e => this.props.searchText(e.target.value)}
                        />
                        <button
                          type="submit"
                          style={{ transform: "scaleX(-1)" }}
                        >
                          <img src={require("../img/header-search.svg")} />
                        </button>
                      </form>
                    </Link>
                  </div>
                  <div
                    className={
                      showFilter
                        ? "dropdown filtersite show"
                        : "dropdown filtersite"
                    }
                  >
                    <div
                      className="filterbtn"
                      onClick={() => this.setState({ showFilter: !showFilter })}
                    >
                      <button type="button" className="dropdown-toggle">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="21.938"
                          height="14.283"
                          viewBox="0 0 21.938 14.283"
                        >
                          {" "}
                          <path
                            id="Shape_3"
                            data-name="Shape 3"
                            d="M617.008,117.9v-1.892h21.938V117.9H617.008Zm18.282,5.946H620.664v-1.887H635.29Zm-4.875,6.445h-4.875v-1.853h4.875Z"
                            transform="translate(-617.008 -116.008)"
                            fill="#666"
                          />{" "}
                        </svg>
                      </button>
                    </div>
                    <div
                      className={
                        showFilter
                          ? "dropdown-backdrop show"
                          : "dropdown-backdrop"
                      }
                      onClick={() => this.setState({ showFilter: false })}
                    ></div>
                    <div
                      className={
                        showFilter
                          ? "dropdown-menu dropdown-menu-right show"
                          : "dropdown-menu dropdown-menu-right"
                      }
                    >
                      <h5 className="text-center">Filter</h5>
                      <p>What kind of contests you are interested in</p>
                      {filterContestList.map((item, index) => (
                        <div className="filterbox" key={"filterbox" + index}>
                          <h4>{item.countryName}</h4>
                          <div className="filtermenu">
                            {item.contest.map((contest, index1) => (
                              <label
                                className="checkbox-styled"
                                key={`itemcontest${index}${index1}`}
                              >
                                <input
                                  type="checkbox"
                                  name="checkbox"
                                  value="checkbox"
                                  checked={contest.isSelected}
                                  onChange={e => {
                                    let temp = e.target;
                                    while (
                                      temp.className == "" ||
                                      !temp.className.includes("dropdown-menu")
                                    ) {
                                      temp = temp.parentElement;
                                    }
                                    this.props.filterListData({
                                      category: item._id,
                                      categoryFlag: item.isSelected,
                                      contest: contest.name,
                                      contestFlag: contest.isSelected
                                    });
                                    return false;
                                  }}
                                />
                                <span>{contest.name}</span>
                              </label>
                            ))}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="col text-right pr-0 pl-0 d-flex align-items-center justify-content-end">
                  <Link to="/voting-tickets" className="ticketslink">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="23.902"
                      height="23.415"
                      viewBox="0 0 23.902 23.415"
                    >
                      {" "}
                      <g
                        id="Group_1024"
                        data-name="Group 1024"
                        transform="translate(-1313.636 -27.06)"
                      >
                        {" "}
                        <g
                          id="Group_986"
                          data-name="Group 986"
                          transform="translate(1313.744 22.018)"
                        >
                          {" "}
                          <path
                            id="Path_152"
                            data-name="Path 152"
                            d="M256.36,209.953l1.656.5.984-1.422.039,1.729,1.656.5-1.632.572.039,1.729-1.048-1.375-1.632.572.984-1.422Z"
                            transform="translate(-244.509 -194.444)"
                            fill="#f2f2f2"
                            stroke="rgba(0,0,0,0)"
                            strokeWidth="1"
                          />{" "}
                          <path
                            id="Path_155"
                            data-name="Path 155"
                            d="M99.118,257.66l1.723-.145.4-1.683.67,1.594,1.723-.144-1.309,1.13.67,1.594-1.479-.9-1.309,1.13.4-1.683Z"
                            transform="translate(-94.536 -239.084)"
                            fill="#fff"
                            stroke="rgba(0,0,0,0)"
                            strokeWidth="1"
                          />{" "}
                          <path
                            id="Path_156"
                            data-name="Path 156"
                            d="M337.19,83.781l1.31.907a.386.386,0,0,0,.439-.635l-1.31-.907a.386.386,0,0,0-.439.635Z"
                            transform="translate(-321.444 -74.315)"
                            fill="#2a2e31"
                            stroke="rgba(0,0,0,0)"
                            strokeWidth="1"
                          />{" "}
                          <path
                            id="Path_157"
                            data-name="Path 157"
                            d="M393.887,123.032l1.31.907a.392.392,0,0,0,.537-.1.386.386,0,0,0-.1-.537l-1.31-.907a.386.386,0,0,0-.439.635Z"
                            transform="translate(-375.521 -111.752)"
                            fill="#2a2e31"
                            stroke="rgba(0,0,0,0)"
                            strokeWidth="1"
                          />{" "}
                          <path
                            id="Path_158"
                            data-name="Path 158"
                            d="M123.478,127.135l1.552.364a.386.386,0,1,0,.176-.751l-1.552-.364a.386.386,0,0,0-.176.751Z"
                            transform="translate(-117.486 -115.61)"
                            fill="#2a2e31"
                            stroke="#2a2e31"
                            strokeWidth="0.2"
                          />{" "}
                          <path
                            id="Path_159"
                            data-name="Path 159"
                            d="M190.612,142.889l1.552.364a.386.386,0,1,0,.176-.751l-1.552-.364a.386.386,0,1,0-.176.751Z"
                            transform="translate(-181.517 -130.636)"
                            fill="#2a2e31"
                            stroke="#2a2e31"
                            strokeWidth="0.2"
                          />{" "}
                          <path
                            id="Path_160"
                            data-name="Path 160"
                            d="M35.54,168.284l6.615,1.552a.386.386,0,0,0,.464-.288L45.329,158a.386.386,0,0,0-.288-.464l-3.516-.825a.386.386,0,1,0-.176.751l3.14.737L41.956,169l-5.864-1.376,2.533-10.8,1.194.28a.386.386,0,1,0,.176-.751l-1.569-.368a.386.386,0,0,0-.464.288l-2.71,11.547A.386.386,0,0,0,35.54,168.284Z"
                            transform="translate(-33.613 -143.843)"
                            fill="#2a2e31"
                            stroke="#2a2e31"
                            strokeWidth="0.2"
                          />{" "}
                          <path
                            id="Path_161"
                            data-name="Path 161"
                            d="M96.021,249.174a.386.386,0,0,0-.388-.235l-1.444.121-.561-1.336a.386.386,0,0,0-.731.061l-.331,1.41-1.444.121a.386.386,0,0,0-.168.715l1.239.751-.331,1.41a.386.386,0,0,0,.628.38l1.1-.947,1.239.751a.386.386,0,0,0,.556-.479l-.561-1.336,1.1-.947A.386.386,0,0,0,96.021,249.174ZM94,250.6l.21.5-.463-.281c-.32-.194-.642.2-.862.392l.124-.527a.386.386,0,0,0-.176-.418l-.463-.281.54-.045c.375-.031.4-.542.467-.824l.21.5c.146.347.639.214.928.19C94.291,250,93.85,250.247,94,250.6Z"
                            transform="translate(-86.572 -231.126)"
                            fill="#2a2e31"
                          />{" "}
                          <path
                            id="Path_162"
                            data-name="Path 162"
                            d="M.3,25.436a.805.805,0,0,1,.616.857.386.386,0,0,0,.3.413l2.337.548A.386.386,0,0,0,4,27.016a.806.806,0,0,1,1.549.363.386.386,0,0,0,.3.413l2.337.548a.39.39,0,0,0,.449-.238.806.806,0,0,1,.749-.515c.17,0,.316.073.476-.026a.386.386,0,0,0,.172-.24l.507-2.162,1.088.754a.391.391,0,0,0,.5-.057.8.8,0,0,1,1.049-.118.386.386,0,0,0,.537-.1L23.6,11.356a.386.386,0,0,0-.1-.537A.805.805,0,0,1,23.242,9.8a.386.386,0,0,0-.124-.492L21.144,7.937a.386.386,0,0,0-.5.057.8.8,0,0,1-.593.261.8.8,0,0,1-.456-.143.805.805,0,0,1-.259-1.023.386.386,0,0,0-.124-.492L17.234,5.229a.386.386,0,0,0-.5.057.805.805,0,0,1-.593.261A.8.8,0,0,1,15.68,5.4a.386.386,0,0,0-.537.1L12.912,8.724a.385.385,0,0,0-.12-.051l-2.337-.548a.386.386,0,0,0-.449.238A.8.8,0,0,1,8.458,8a.386.386,0,0,0-.3-.413L5.825,7.038a.386.386,0,0,0-.449.238.814.814,0,0,1-.933.494.386.386,0,0,0-.464.288L3.4,10.522.011,24.972A.386.386,0,0,0,.3,25.436ZM15.585,6.219a1.576,1.576,0,0,0,1.455-.185L18.522,7.06a1.575,1.575,0,0,0,2.428,1.681l1.482,1.026a1.586,1.586,0,0,0,.339,1.426l-1.028,1.486-.317-.22a.386.386,0,0,0-.439.635l.317.22L13.267,24.923a1.565,1.565,0,0,0-.551-.1,1.581,1.581,0,0,0-.9.285l-1.093-.756.392-1.671,1.707,1.181a.389.389,0,0,0,.537-.1L18.318,16.6a.386.386,0,1,0-.634-.439l-4.743,6.85L11.3,21.873l.752-3.206,1.355-.475.878,1.152a.386.386,0,0,0,.693-.243l-.033-1.448,1.367-.479a.386.386,0,0,0-.017-.734l-1.388-.416-.033-1.448a.386.386,0,0,0-.7-.211l-.825,1.191-.528-.158.993-4.233.486-.7,4.952,3.429-.671.97a.386.386,0,1,0,.634.439l.891-1.287a.391.391,0,0,0-.1-.537L14.422,9.608a.389.389,0,0,0-.537.1l-.167.242-.014,0a.805.805,0,0,1-.472-.319l0,0,.888-1.282.317.22a.391.391,0,0,0,.537-.1.386.386,0,0,0-.1-.537l-.317-.22Zm-1.4,11.713-.328-.431a.39.39,0,0,0-.435-.13l-.511.179c.168-.243.533-.59.3-.9l-.328-.431.519.156c.362.108.57-.355.736-.6l.012.541c.009.376.516.433.794.516l-.511.179a.386.386,0,0,0-.258.373ZM4.065,11.073l.376.088a.386.386,0,1,0,.176-.751l-.376-.088.413-1.759a1.585,1.585,0,0,0,1.286-.705l1.755.412a1.574,1.574,0,0,0,2.875.675l1.755.412a1,1,0,0,1,.018.112,1.58,1.58,0,0,0,.108.335,1.6,1.6,0,0,0,.712.756l-.413,1.759-.376-.088a.386.386,0,1,0-.176.751l.376.088-.614,2.615-.067.286-.451,1.92-.953,4.061-.582,2.479-.56,2.385a1.584,1.584,0,0,0-1.286.705l-1.755-.412a1.574,1.574,0,0,0-2.875-.675l-1.755-.412a1.586,1.586,0,0,0-.838-1.2Z"
                            transform="translate(0 0)"
                            fill="#2a2e31"
                            stroke="#2a2e31"
                            strokeWidth="0.2"
                          />{" "}
                        </g>{" "}
                      </g>{" "}
                    </svg>
                    <span className="notifybedge">{ticketCount}</span>
                  </Link>
                  <div className="dropdown notification">
                    <button
                      type="button"
                      className="dropdown-toggle"
                      data-toggle="dropdown"
                      style={{ "margin-left": "7px" }}
                    >
                      <svg
                        className="showdefault"
                        xmlns="http://www.w3.org/2000/svg"
                        width="19.119"
                        height="23.368"
                        viewBox="0 0 19.119 23.368"
                      >
                        <path
                          id="Path_122"
                          data-name="Path 122"
                          d="M80.995,32.486V30.893a7.446,7.446,0,0,0-5.311-7.122v-.313a2.124,2.124,0,1,0-4.249,0v.313a7.446,7.446,0,0,0-5.311,7.122v1.593c0,3.536-.832,4.778-1.44,5.685A3.007,3.007,0,0,0,64,39.921c0,1.731,3.61,2.339,6.536,2.548a3.164,3.164,0,0,0,6.047,0c2.926-.209,6.536-.817,6.536-2.548a3.006,3.006,0,0,0-.685-1.75C81.827,37.264,80.995,36.022,80.995,32.486Zm-8.5-9.029a1.062,1.062,0,0,1,2.124,0v.085a6.691,6.691,0,0,0-2.124,0v-.085ZM73.56,43.639a2.106,2.106,0,0,1-1.853-1.1c.753.032,1.406.041,1.853.041s1.1-.009,1.853-.041A2.106,2.106,0,0,1,73.56,43.639Zm0-2.124c-4.864,0-8.5-.841-8.5-1.593a2.021,2.021,0,0,1,.505-1.159c.644-.963,1.619-2.417,1.619-6.276V30.893a6.373,6.373,0,1,1,12.746,0v1.593c0,3.859.975,5.314,1.619,6.276a2.022,2.022,0,0,1,.505,1.159C82.057,40.673,78.423,41.514,73.56,41.514Z"
                          transform="translate(-64 -21.333)"
                        />
                      </svg>
                      <svg
                        className="showclick"
                        xmlns="http://www.w3.org/2000/svg"
                        width="19.119"
                        height="23.368"
                        viewBox="0 0 19.119 23.368"
                      >
                        <path
                          id="Path_123"
                          data-name="Path 123"
                          d="M80.995,32.486V30.893a7.446,7.446,0,0,0-5.311-7.122v-.313a2.124,2.124,0,1,0-4.249,0v.313a7.446,7.446,0,0,0-5.311,7.122v1.593c0,3.536-.832,4.778-1.44,5.685A3.007,3.007,0,0,0,64,39.921c0,1.731,3.61,2.339,6.536,2.548a3.164,3.164,0,0,0,6.047,0c2.926-.209,6.536-.817,6.536-2.548a3.006,3.006,0,0,0-.685-1.75C81.827,37.264,80.995,36.022,80.995,32.486Zm-8.5-9.029a1.062,1.062,0,0,1,2.124,0v.085a6.691,6.691,0,0,0-2.124,0v-.085Z"
                          transform="translate(-64 -21.333)"
                        />
                      </svg>
                      {notifications.unreadCount &&
                      notifications.unreadCount[0] &&
                      notifications.unreadCount[0].count > 0 ? (
                        <span className="notifybedge">
                          {notifications.unreadCount
                            ? Number(notifications.unreadCount[0].count) > 99
                              ? "99+"
                              : notifications.unreadCount[0].count
                            : 0}
                        </span>
                      ) : null}
                    </button>
                    <div
                      id="notificationScrollContainerDesktop"
                      className="dropdown-menu"
                      style={{ overflowY: "scroll" }}
                    >
                      {notifications.list.length == 0 ? null : (
                        <InfiniteScroll
                          dataLength={notifications.list.length}
                          next={this.fetchMoreData}
                          hasMore={hasMore}
                          scrollableTarget="notificationScrollContainerDesktop"
                          loader={
                            <div className="text-center">
                              <Image
                                className="loaderfade"
                                src={require("../img/loader1.svg")}
                              />
                            </div>
                          }
                        >
                          {notifications
                            ? notifications.list.map((item, index) => (
                                <a
                                  key={"notificationDesk" + index}
                                  className={
                                    "dropdown-item " +
                                    (item.isRead ? "read" : "unread")
                                  }
                                  onClick={() =>
                                    this.notificationRedirect(item, index)
                                  }
                                >
                                  {!item.isRead ? (
                                    <span>
                                      <i className="fa fa-circle notificationUnreadBadge"></i>
                                    </span>
                                  ) : null}
                                  <CloudinaryImage
                                    cloudName={cloudName}
                                    publicId={item.profilePic}
                                    crop="scale"
                                    className="rounded-circle"
                                  />
                                  <div className="votnote">
                                    <h5>
                                      {item.firstName} {item.lastName}
                                    </h5>
                                    <p>{item.body}</p>
                                    <span>
                                      {moment(item.created).format(
                                        "DD-MMM-YYYY"
                                      )}
                                    </span>
                                  </div>
                                </a>
                              ))
                            : null}
                        </InfiniteScroll>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </nav>

            <nav className="navbar fixed-top navbar-light bg-light pl-0 pr-0 navbar-mobile">
              <div
                className={pathname.length == 1 ? "container-big" : "container"}
              >
                <div className="col text-left pr-0 pl-0 d-flex align-items-center justify-content-start">
                  <div className="filterbtn">
                    <a
                      href="#filtermodal"
                      data-toggle="modal"
                      aria-expanded="false"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="21.938"
                        height="14.283"
                        viewBox="0 0 21.938 14.283"
                      >
                        {" "}
                        <path
                          id="Shape_3"
                          data-name="Shape 3"
                          d="M617.008,117.9v-1.892h21.938V117.9H617.008Zm18.282,5.946H620.664v-1.887H635.29Zm-4.875,6.445h-4.875v-1.853h4.875Z"
                          transform="translate(-617.008 -116.008)"
                          fill="#666"
                        />{" "}
                      </svg>
                    </a>
                  </div>
                </div>
                <div className="col text-center pl-0 pr-0">
                  <Link to="/" className="logo">
                    <img
                      src={require("../img/contestee-logo-small.svg")}
                      alt="Contestee Logo"
                    />
                  </Link>
                </div>
                <div className="col text-right pr-0 pl-0 d-flex align-items-center justify-content-end">
                  <Link to="/voting-tickets" className="ticketslink">
                    <span className="notifybedge">{ticketCount}</span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="23.902"
                      height="23.415"
                      viewBox="0 0 23.902 23.415"
                    >
                      {" "}
                      <g
                        id="Group_1024"
                        data-name="Group 1024"
                        transform="translate(-1313.636 -27.06)"
                      >
                        {" "}
                        <g
                          id="Group_986"
                          data-name="Group 986"
                          transform="translate(1313.744 22.018)"
                        >
                          {" "}
                          <path
                            id="Path_152"
                            data-name="Path 152"
                            d="M256.36,209.953l1.656.5.984-1.422.039,1.729,1.656.5-1.632.572.039,1.729-1.048-1.375-1.632.572.984-1.422Z"
                            transform="translate(-244.509 -194.444)"
                            fill="#f2f2f2"
                            stroke="rgba(0,0,0,0)"
                            strokeWidth="1"
                          />{" "}
                          <path
                            id="Path_155"
                            data-name="Path 155"
                            d="M99.118,257.66l1.723-.145.4-1.683.67,1.594,1.723-.144-1.309,1.13.67,1.594-1.479-.9-1.309,1.13.4-1.683Z"
                            transform="translate(-94.536 -239.084)"
                            fill="#fff"
                            stroke="rgba(0,0,0,0)"
                            strokeWidth="1"
                          />{" "}
                          <path
                            id="Path_156"
                            data-name="Path 156"
                            d="M337.19,83.781l1.31.907a.386.386,0,0,0,.439-.635l-1.31-.907a.386.386,0,0,0-.439.635Z"
                            transform="translate(-321.444 -74.315)"
                            fill="#2a2e31"
                            stroke="rgba(0,0,0,0)"
                            strokeWidth="1"
                          />{" "}
                          <path
                            id="Path_157"
                            data-name="Path 157"
                            d="M393.887,123.032l1.31.907a.392.392,0,0,0,.537-.1.386.386,0,0,0-.1-.537l-1.31-.907a.386.386,0,0,0-.439.635Z"
                            transform="translate(-375.521 -111.752)"
                            fill="#2a2e31"
                            stroke="rgba(0,0,0,0)"
                            strokeWidth="1"
                          />{" "}
                          <path
                            id="Path_158"
                            data-name="Path 158"
                            d="M123.478,127.135l1.552.364a.386.386,0,1,0,.176-.751l-1.552-.364a.386.386,0,0,0-.176.751Z"
                            transform="translate(-117.486 -115.61)"
                            fill="#2a2e31"
                            stroke="#2a2e31"
                            strokeWidth="0.2"
                          />{" "}
                          <path
                            id="Path_159"
                            data-name="Path 159"
                            d="M190.612,142.889l1.552.364a.386.386,0,1,0,.176-.751l-1.552-.364a.386.386,0,1,0-.176.751Z"
                            transform="translate(-181.517 -130.636)"
                            fill="#2a2e31"
                            stroke="#2a2e31"
                            strokeWidth="0.2"
                          />{" "}
                          <path
                            id="Path_160"
                            data-name="Path 160"
                            d="M35.54,168.284l6.615,1.552a.386.386,0,0,0,.464-.288L45.329,158a.386.386,0,0,0-.288-.464l-3.516-.825a.386.386,0,1,0-.176.751l3.14.737L41.956,169l-5.864-1.376,2.533-10.8,1.194.28a.386.386,0,1,0,.176-.751l-1.569-.368a.386.386,0,0,0-.464.288l-2.71,11.547A.386.386,0,0,0,35.54,168.284Z"
                            transform="translate(-33.613 -143.843)"
                            fill="#2a2e31"
                            stroke="#2a2e31"
                            strokeWidth="0.2"
                          />{" "}
                          <path
                            id="Path_161"
                            data-name="Path 161"
                            d="M96.021,249.174a.386.386,0,0,0-.388-.235l-1.444.121-.561-1.336a.386.386,0,0,0-.731.061l-.331,1.41-1.444.121a.386.386,0,0,0-.168.715l1.239.751-.331,1.41a.386.386,0,0,0,.628.38l1.1-.947,1.239.751a.386.386,0,0,0,.556-.479l-.561-1.336,1.1-.947A.386.386,0,0,0,96.021,249.174ZM94,250.6l.21.5-.463-.281c-.32-.194-.642.2-.862.392l.124-.527a.386.386,0,0,0-.176-.418l-.463-.281.54-.045c.375-.031.4-.542.467-.824l.21.5c.146.347.639.214.928.19C94.291,250,93.85,250.247,94,250.6Z"
                            transform="translate(-86.572 -231.126)"
                            fill="#2a2e31"
                          />{" "}
                          <path
                            id="Path_162"
                            data-name="Path 162"
                            d="M.3,25.436a.805.805,0,0,1,.616.857.386.386,0,0,0,.3.413l2.337.548A.386.386,0,0,0,4,27.016a.806.806,0,0,1,1.549.363.386.386,0,0,0,.3.413l2.337.548a.39.39,0,0,0,.449-.238.806.806,0,0,1,.749-.515c.17,0,.316.073.476-.026a.386.386,0,0,0,.172-.24l.507-2.162,1.088.754a.391.391,0,0,0,.5-.057.8.8,0,0,1,1.049-.118.386.386,0,0,0,.537-.1L23.6,11.356a.386.386,0,0,0-.1-.537A.805.805,0,0,1,23.242,9.8a.386.386,0,0,0-.124-.492L21.144,7.937a.386.386,0,0,0-.5.057.8.8,0,0,1-.593.261.8.8,0,0,1-.456-.143.805.805,0,0,1-.259-1.023.386.386,0,0,0-.124-.492L17.234,5.229a.386.386,0,0,0-.5.057.805.805,0,0,1-.593.261A.8.8,0,0,1,15.68,5.4a.386.386,0,0,0-.537.1L12.912,8.724a.385.385,0,0,0-.12-.051l-2.337-.548a.386.386,0,0,0-.449.238A.8.8,0,0,1,8.458,8a.386.386,0,0,0-.3-.413L5.825,7.038a.386.386,0,0,0-.449.238.814.814,0,0,1-.933.494.386.386,0,0,0-.464.288L3.4,10.522.011,24.972A.386.386,0,0,0,.3,25.436ZM15.585,6.219a1.576,1.576,0,0,0,1.455-.185L18.522,7.06a1.575,1.575,0,0,0,2.428,1.681l1.482,1.026a1.586,1.586,0,0,0,.339,1.426l-1.028,1.486-.317-.22a.386.386,0,0,0-.439.635l.317.22L13.267,24.923a1.565,1.565,0,0,0-.551-.1,1.581,1.581,0,0,0-.9.285l-1.093-.756.392-1.671,1.707,1.181a.389.389,0,0,0,.537-.1L18.318,16.6a.386.386,0,1,0-.634-.439l-4.743,6.85L11.3,21.873l.752-3.206,1.355-.475.878,1.152a.386.386,0,0,0,.693-.243l-.033-1.448,1.367-.479a.386.386,0,0,0-.017-.734l-1.388-.416-.033-1.448a.386.386,0,0,0-.7-.211l-.825,1.191-.528-.158.993-4.233.486-.7,4.952,3.429-.671.97a.386.386,0,1,0,.634.439l.891-1.287a.391.391,0,0,0-.1-.537L14.422,9.608a.389.389,0,0,0-.537.1l-.167.242-.014,0a.805.805,0,0,1-.472-.319l0,0,.888-1.282.317.22a.391.391,0,0,0,.537-.1.386.386,0,0,0-.1-.537l-.317-.22Zm-1.4,11.713-.328-.431a.39.39,0,0,0-.435-.13l-.511.179c.168-.243.533-.59.3-.9l-.328-.431.519.156c.362.108.57-.355.736-.6l.012.541c.009.376.516.433.794.516l-.511.179a.386.386,0,0,0-.258.373ZM4.065,11.073l.376.088a.386.386,0,1,0,.176-.751l-.376-.088.413-1.759a1.585,1.585,0,0,0,1.286-.705l1.755.412a1.574,1.574,0,0,0,2.875.675l1.755.412a1,1,0,0,1,.018.112,1.58,1.58,0,0,0,.108.335,1.6,1.6,0,0,0,.712.756l-.413,1.759-.376-.088a.386.386,0,1,0-.176.751l.376.088-.614,2.615-.067.286-.451,1.92-.953,4.061-.582,2.479-.56,2.385a1.584,1.584,0,0,0-1.286.705l-1.755-.412a1.574,1.574,0,0,0-2.875-.675l-1.755-.412a1.586,1.586,0,0,0-.838-1.2Z"
                            transform="translate(0 0)"
                            fill="#2a2e31"
                            stroke="#2a2e31"
                            strokeWidth="0.2"
                          />{" "}
                        </g>{" "}
                      </g>{" "}
                    </svg>
                  </Link>
                  <div className="dropdown notification">
                    <button
                      type="button"
                      className="dropdown-toggle"
                      data-toggle="dropdown"
                    >
                      <svg
                        className="showdefault"
                        xmlns="http://www.w3.org/2000/svg"
                        width="19.119"
                        height="23.368"
                        viewBox="0 0 19.119 23.368"
                      >
                        <path
                          id="Path_122"
                          data-name="Path 122"
                          d="M80.995,32.486V30.893a7.446,7.446,0,0,0-5.311-7.122v-.313a2.124,2.124,0,1,0-4.249,0v.313a7.446,7.446,0,0,0-5.311,7.122v1.593c0,3.536-.832,4.778-1.44,5.685A3.007,3.007,0,0,0,64,39.921c0,1.731,3.61,2.339,6.536,2.548a3.164,3.164,0,0,0,6.047,0c2.926-.209,6.536-.817,6.536-2.548a3.006,3.006,0,0,0-.685-1.75C81.827,37.264,80.995,36.022,80.995,32.486Zm-8.5-9.029a1.062,1.062,0,0,1,2.124,0v.085a6.691,6.691,0,0,0-2.124,0v-.085ZM73.56,43.639a2.106,2.106,0,0,1-1.853-1.1c.753.032,1.406.041,1.853.041s1.1-.009,1.853-.041A2.106,2.106,0,0,1,73.56,43.639Zm0-2.124c-4.864,0-8.5-.841-8.5-1.593a2.021,2.021,0,0,1,.505-1.159c.644-.963,1.619-2.417,1.619-6.276V30.893a6.373,6.373,0,1,1,12.746,0v1.593c0,3.859.975,5.314,1.619,6.276a2.022,2.022,0,0,1,.505,1.159C82.057,40.673,78.423,41.514,73.56,41.514Z"
                          transform="translate(-64 -21.333)"
                        />
                      </svg>
                      <svg
                        className="showclick"
                        xmlns="http://www.w3.org/2000/svg"
                        width="19.119"
                        height="23.368"
                        viewBox="0 0 19.119 23.368"
                      >
                        <path
                          id="Path_123"
                          data-name="Path 123"
                          d="M80.995,32.486V30.893a7.446,7.446,0,0,0-5.311-7.122v-.313a2.124,2.124,0,1,0-4.249,0v.313a7.446,7.446,0,0,0-5.311,7.122v1.593c0,3.536-.832,4.778-1.44,5.685A3.007,3.007,0,0,0,64,39.921c0,1.731,3.61,2.339,6.536,2.548a3.164,3.164,0,0,0,6.047,0c2.926-.209,6.536-.817,6.536-2.548a3.006,3.006,0,0,0-.685-1.75C81.827,37.264,80.995,36.022,80.995,32.486Zm-8.5-9.029a1.062,1.062,0,0,1,2.124,0v.085a6.691,6.691,0,0,0-2.124,0v-.085Z"
                          transform="translate(-64 -21.333)"
                        />
                      </svg>
                      {notifications.unreadCount &&
                      notifications.unreadCount[0] &&
                      notifications.unreadCount[0].count > 0 ? (
                        <span className="notifybedge">
                          {notifications.unreadCount
                            ? Number(notifications.unreadCount[0].count) > 99
                              ? "99+"
                              : notifications.unreadCount[0].count
                            : 0}
                        </span>
                      ) : null}
                    </button>
                    <div
                      id="notificationScrollContainerMobile"
                      className="dropdown-menu"
                    >
                      {notifications.list.length == 0 ? null : (
                        <InfiniteScroll
                          dataLength={notifications.list.length}
                          next={this.fetchMoreData}
                          hasMore={hasMore}
                          scrollableTarget="notificationScrollContainerMobile"
                          loader={
                            <div className="text-center">
                              <Image src={require("../img/loader1.svg")} />
                            </div>
                          }
                        >
                          {notifications
                            ? notifications.list.map((item, index) => (
                                <a
                                  key={"notificationMobile" + index}
                                  className={
                                    "dropdown-item " +
                                    (item.isRead ? "read" : "unread")
                                  }
                                  onClick={() =>
                                    this.notificationRedirect(item, index)
                                  }
                                >
                                  {!item.isRead ? (
                                    <span>
                                      {" "}
                                      <i className="fa fa-circle notificationUnreadBadge"></i>
                                    </span>
                                  ) : null}
                                  <CloudinaryImage
                                    cloudName={cloudName}
                                    publicId={item.profilePic}
                                    crop="scale"
                                    className="rounded-circle"
                                  />
                                  <div className="votnote">
                                    <h5>
                                      {item.firstName} {item.lastName}
                                    </h5>
                                    <p>{item.body}</p>
                                    <span>
                                      {moment(item.created).format(
                                        "DD-MMM-YYYY"
                                      )}
                                    </span>
                                  </div>
                                </a>
                              ))
                            : null}
                        </InfiniteScroll>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </nav>

            <section
              className={
                pathname.includes("enroll")
                  ? "main enrollment"
                  : pathname.includes("contest")
                  ? "main detailpage"
                  : pathname.includes("/media/")
                  ? "main detailpage"
                  : "main"
              }
            >
              <div className="container" data-sticky_parent>
                <div
                  className={
                    pathname.length == 1
                      ? "homepage"
                      : pathname.includes("explore")
                      ? "explorepage"
                      : ""
                  }
                >
                  <div className="row ml-0 mr-0">
                    <div className="col-md-4 col-lg-3 pl-0">
                      <div className="sidemenu" data-sticky_column>
                        <div className="box box-bottom-mobile navbar-desktop">
                          <h3 className="section-title1">Menu</h3>
                          <ul>
                            <li
                              className={
                                pathname.length == 1 ||
                                (pathname.includes("contest") &&
                                  !pathname.includes("profile"))
                                  ? "active"
                                  : ""
                              }
                            >
                              <NavLink to="/">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="22.771"
                                  height="20.778"
                                  viewBox="0 0 22.771 20.778"
                                >
                                  {" "}
                                  <g
                                    id="Group_540"
                                    data-name="Group 540"
                                    transform="translate(-0.098 -45)"
                                  >
                                    {" "}
                                    <path
                                      id="Path_256"
                                      data-name="Path 256"
                                      d="M381.338,116.464v-4.458H379.2v2.384Z"
                                      transform="translate(-362.233 -64.025)"
                                      fill="#b32425"
                                    />{" "}
                                    <path
                                      id="Path_257"
                                      data-name="Path 257"
                                      d="M400.232,112.006V115.3l1.2,1.166v-4.458Z"
                                      transform="translate(-382.331 -64.025)"
                                      fill="#9e1219"
                                    />{" "}
                                    <g
                                      id="Group_540-2"
                                      data-name="Group 540"
                                      transform="translate(2.617 48.335)"
                                    >
                                      {" "}
                                      <path
                                        id="Path_258"
                                        data-name="Path 258"
                                        d="M66.27,120.254a.958.958,0,0,0-1.391,0l-8.172,7.921v8.794H74.442v-8.794Z"
                                        transform="translate(-56.707 -119.955)"
                                        fill="#e0e0e0"
                                      />{" "}
                                    </g>{" "}
                                    <path
                                      id="Path_259"
                                      data-name="Path 259"
                                      d="M428.25,278.5v9.96h1.2v-8.794Z"
                                      transform="translate(-409.101 -223.107)"
                                      fill="#c4c4c4"
                                    />{" "}
                                    <path
                                      id="Path_260"
                                      data-name="Path 260"
                                      d="M29.344,64.588l-10-9.691a.958.958,0,0,0-1.391,0l-10,9.691a1.389,1.389,0,0,0-.177,1.625h0a.781.781,0,0,0,1.266.227L17.955,57.8a.958.958,0,0,1,1.391,0l8.908,8.635a.781.781,0,0,0,1.266-.227h0A1.389,1.389,0,0,0,29.344,64.588Z"
                                      transform="translate(-7.166 -9.171)"
                                      fill="#ff3d43"
                                    />{" "}
                                    <path
                                      id="Path_261"
                                      data-name="Path 261"
                                      d="M28.257,94.18l-8.908-8.635a.958.958,0,0,0-1.391,0L9.05,94.18a.769.769,0,0,1-1.219-.154A1.421,1.421,0,0,0,7.784,95.5h0a.781.781,0,0,0,1.266.227l8.908-8.635a.958.958,0,0,1,1.391,0l8.908,8.635a.781.781,0,0,0,1.266-.227h0a1.421,1.421,0,0,0-.047-1.472A.769.769,0,0,1,28.257,94.18Z"
                                      transform="translate(-7.169 -38.455)"
                                      fill="#d72e2e"
                                    />{" "}
                                    <path
                                      id="Path_262"
                                      data-name="Path 262"
                                      d="M218.131,333.272h-3.7v-5.506a2.157,2.157,0,0,1,1.849-2.368h0a2.157,2.157,0,0,1,1.849,2.368Z"
                                      transform="translate(-204.797 -267.923)"
                                      fill="#6e563d"
                                    />{" "}
                                    <path
                                      id="Path_263"
                                      data-name="Path 263"
                                      d="M243.08,325.4a1.486,1.486,0,0,0-.6.129,2.4,2.4,0,0,1,1.248,2.239v5.506h1.2v-5.506A2.157,2.157,0,0,0,243.08,325.4Z"
                                      transform="translate(-231.595 -267.923)"
                                      fill="#604b35"
                                    />{" "}
                                    <path
                                      id="Path_264"
                                      data-name="Path 264"
                                      d="M110.476,328.832h-1.755a.537.537,0,0,1-.46-.59V325.99a.537.537,0,0,1,.46-.59h1.755a.537.537,0,0,1,.46.59v2.252A.537.537,0,0,1,110.476,328.832Z"
                                      transform="translate(-103.351 -267.924)"
                                      fill="#8cc7ec"
                                    />{" "}
                                    <path
                                      id="Path_265"
                                      data-name="Path 265"
                                      d="M345.1,328.832h1.755a.537.537,0,0,0,.46-.59V325.99a.537.537,0,0,0-.46-.59H345.1a.537.537,0,0,0-.46.59v2.252A.537.537,0,0,0,345.1,328.832Z"
                                      transform="translate(-329.216 -267.924)"
                                      fill="#8cc7ec"
                                    />{" "}
                                    <path
                                      id="Path_266"
                                      data-name="Path 266"
                                      d="M132.188,325.4h-1.2a.537.537,0,0,1,.46.59v2.252a.537.537,0,0,1-.46.59h1.2a.537.537,0,0,0,.46-.59v-2.252A.537.537,0,0,0,132.188,325.4Z"
                                      transform="translate(-125.063 -267.923)"
                                      fill="#66baea"
                                    />{" "}
                                    <path
                                      id="Path_267"
                                      data-name="Path 267"
                                      d="M368.569,325.4h-1.2a.537.537,0,0,1,.46.59v2.252a.537.537,0,0,1-.46.59h1.2a.537.537,0,0,0,.46-.59v-2.252A.537.537,0,0,0,368.569,325.4Z"
                                      transform="translate(-350.927 -267.923)"
                                      fill="#66baea"
                                    />{" "}
                                    <g
                                      id="Group_541"
                                      data-name="Group 541"
                                      transform="translate(0.098 45)"
                                    >
                                      {" "}
                                      <path
                                        id="Path_268"
                                        data-name="Path 268"
                                        d="M22.379,55.075l-2.94-2.849V47.981a.391.391,0,0,0-.334-.429H16.966a.391.391,0,0,0-.334.429V49.5l-4.25-4.12a1.24,1.24,0,0,0-1.794,0L4.466,51.318a.514.514,0,0,0-.065.6A.289.289,0,0,0,4.869,52l6.121-5.934a.683.683,0,0,1,.988,0l10,9.691a.877.877,0,0,1,.111,1.024.493.493,0,0,1-.8.143l-8.908-8.635a1.24,1.24,0,0,0-1.794,0L1.68,56.927a.493.493,0,0,1-.8-.143A.877.877,0,0,1,.993,55.76L3.8,53.036a.514.514,0,0,0,.065-.6.289.289,0,0,0-.468-.084L.59,55.075A1.905,1.905,0,0,0,.348,57.3a1.07,1.07,0,0,0,1.734.31l.2-.194V65.35a.391.391,0,0,0,.334.429H20.352a.391.391,0,0,0,.334-.429V62.342a.345.345,0,1,0-.669,0v2.579H13.668V59.85c0-1.545-.98-2.8-2.184-2.8S9.3,58.3,9.3,59.85v5.071H2.951V56.769l8.039-7.792a.683.683,0,0,1,.988,0l8.039,7.793v3.857a.345.345,0,1,0,.669,0V57.417l.2.194a1.066,1.066,0,0,0,.745.32,1.168,1.168,0,0,0,.99-.631A1.906,1.906,0,0,0,22.379,55.075ZM17.3,48.41h1.471v3.167L17.3,50.152ZM9.969,59.85A1.773,1.773,0,0,1,11.484,57.9,1.773,1.773,0,0,1,13,59.85v5.071H9.969Z"
                                        transform="translate(-0.098 -45)"
                                      />{" "}
                                      <path
                                        id="Path_269"
                                        data-name="Path 269"
                                        d="M101.544,315.756a.929.929,0,0,0-.794,1.019v2.252a.929.929,0,0,0,.794,1.019H103.3a.929.929,0,0,0,.794-1.019v-2.252a.929.929,0,0,0-.794-1.019h-1.755Zm1.88,1.019v2.252a.147.147,0,0,1-.125.161h-1.755a.147.147,0,0,1-.125-.161v-2.252a.147.147,0,0,1,.125-.161H103.3A.147.147,0,0,1,103.424,316.775Z"
                                        transform="translate(-96.272 -303.709)"
                                      />{" "}
                                      <path
                                        id="Path_270"
                                        data-name="Path 270"
                                        d="M337.925,315.756a.929.929,0,0,0-.794,1.019v2.252a.929.929,0,0,0,.794,1.019h1.755a.929.929,0,0,0,.794-1.019v-2.252a.929.929,0,0,0-.794-1.019h-1.755Zm1.88,1.019v2.252a.147.147,0,0,1-.125.161h-1.755a.147.147,0,0,1-.125-.161v-2.252a.147.147,0,0,1,.125-.161h1.755A.147.147,0,0,1,339.8,316.775Z"
                                        transform="translate(-322.135 -303.709)"
                                      />{" "}
                                    </g>{" "}
                                  </g>{" "}
                                </svg>{" "}
                                <span>Home</span>
                              </NavLink>
                            </li>
                            <li
                              className={
                                pathname.includes("explore") ? "active" : ""
                              }
                            >
                              <NavLink to="/explore">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="22.443"
                                  height="22.443"
                                  viewBox="0 0 22.443 22.443"
                                >
                                  <g
                                    id="Group_1"
                                    data-name="Group 1"
                                    transform="translate(-0.333 -0.333)"
                                  >
                                    <g
                                      id="Group_1275"
                                      data-name="Group 1275"
                                      transform="translate(0.333 0.333)"
                                    >
                                      <circle
                                        id="Ellipse_110"
                                        data-name="Ellipse 110"
                                        cx="10.801"
                                        cy="10.801"
                                        r="10.801"
                                        transform="translate(0.421 0.421)"
                                        fill="#17a0e5"
                                      />
                                      <path
                                        id="Path_598"
                                        data-name="Path 598"
                                        d="M11.555,22.776A11.222,11.222,0,1,1,22.776,11.555,11.235,11.235,0,0,1,11.555,22.776Zm0-21.6a10.38,10.38,0,1,0,10.38,10.38A10.392,10.392,0,0,0,11.555,1.175Z"
                                        transform="translate(-0.333 -0.333)"
                                      />
                                    </g>
                                    <g
                                      id="Group_1276"
                                      data-name="Group 1276"
                                      transform="translate(6.084 6.505)"
                                    >
                                      <path
                                        id="Path_599"
                                        data-name="Path 599"
                                        d="M24.52,15.842h-10.1a.421.421,0,1,1,0-.842h10.1a.421.421,0,1,1,0,.842Z"
                                        transform="translate(-14 -15)"
                                      />
                                    </g>
                                    <g
                                      id="Group_1277"
                                      data-name="Group 1277"
                                      transform="translate(6.084 11.134)"
                                    >
                                      <path
                                        id="Path_600"
                                        data-name="Path 600"
                                        d="M24.52,26.842h-10.1a.421.421,0,1,1,0-.842h10.1a.421.421,0,1,1,0,.842Z"
                                        transform="translate(-14 -26)"
                                      />
                                    </g>
                                    <g
                                      id="Group_1278"
                                      data-name="Group 1278"
                                      transform="translate(6.084 15.763)"
                                    >
                                      <path
                                        id="Path_601"
                                        data-name="Path 601"
                                        d="M24.52,37.842h-10.1a.421.421,0,1,1,0-.842h10.1a.421.421,0,1,1,0,.842Z"
                                        transform="translate(-14 -37)"
                                      />
                                    </g>
                                  </g>
                                </svg>{" "}
                                <span>Explore</span>
                              </NavLink>
                            </li>
                            <li
                              className={
                                pathname.includes("profile") ? "active" : ""
                              }
                            >
                              <NavLink to="/profile">
                                <svg
                                  id="Group_524"
                                  data-name="Group 524"
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="22.198"
                                  height="22.198"
                                  viewBox="0 0 22.198 22.198"
                                >
                                  {" "}
                                  <circle
                                    id="Ellipse_53"
                                    data-name="Ellipse 53"
                                    cx="10.696"
                                    cy="10.696"
                                    r="10.696"
                                    transform="translate(0.404 0.404)"
                                    fill="#a4c2f7"
                                  />{" "}
                                  <ellipse
                                    id="Ellipse_54"
                                    data-name="Ellipse 54"
                                    cx="10.09"
                                    cy="10.696"
                                    rx="10.09"
                                    ry="10.696"
                                    transform="translate(0.404 0.404)"
                                    fill="#e3e7f2"
                                  />{" "}
                                  <path
                                    id="Path_190"
                                    data-name="Path 190"
                                    d="M20,30.7c.1,0,.208,0,.312-.008-5.436-.165-9.8-4.885-9.8-10.688s4.36-10.522,9.8-10.688c-.1,0-.207-.008-.312-.008A10.7,10.7,0,0,0,20,30.7Z"
                                    transform="translate(-8.905 -8.905)"
                                    fill="#fff"
                                  />{" "}
                                  <path
                                    id="Path_191"
                                    data-name="Path 191"
                                    d="M100.855,97.324l-3.191,1.741a2.857,2.857,0,0,0-.512.365,10.69,10.69,0,0,0,13.734.035,2.857,2.857,0,0,0-.563-.377L106.9,97.379a1.3,1.3,0,0,1-.72-1.166V94.872a5.161,5.161,0,0,0,.323-.416,7.863,7.863,0,0,0,1.062-2.141,1.073,1.073,0,0,0,.761-1.021V89.864a1.067,1.067,0,0,0-.358-.793V87s.425-3.22-3.935-3.22S100.1,87,100.1,87v2.069a1.067,1.067,0,0,0-.358.793v1.431a1.073,1.073,0,0,0,.495.9,7.1,7.1,0,0,0,1.294,2.677V96.18A1.3,1.3,0,0,1,100.855,97.324Z"
                                    transform="translate(-92.939 -80.15)"
                                    fill="#7facfa"
                                  />{" "}
                                  <path
                                    id="Path_192"
                                    data-name="Path 192"
                                    d="M103.172,98.453l-4.5-1.709a1.3,1.3,0,0,1-.72-1.166V94.238a5.164,5.164,0,0,0,.323-.416,7.863,7.863,0,0,0,1.062-2.141,1.073,1.073,0,0,0,.761-1.021V89.23a1.067,1.067,0,0,0-.358-.793V86.368s.425-3.22-3.935-3.22c-.26,0-.5.012-.728.034a.467.467,0,0,1-.287.491,11.265,11.265,0,0,0-1.511.757.415.415,0,0,1,.344.411,14.738,14.738,0,0,1-.884,4.749c.014.6.027,1.2.045,1.794.044.138.088.276.132.414a.466.466,0,0,1,.187.216c.184.439.39.889.568,1.347a.5.5,0,0,1,.592.292,5.4,5.4,0,0,1,.293,1.377.348.348,0,0,1-.174.349,6.014,6.014,0,0,1-1.114,2.129.44.44,0,0,1-.73-.193,2.173,2.173,0,0,1-.053-.228c-.3.178-.622.334-.969.528a9.528,9.528,0,0,0-1.639.916c-.2.913,3,2.046,4.608,2.686a10.729,10.729,0,0,0,1.32.091c2.6,0,6.07-.932,7.925-2.48a2.858,2.858,0,0,0-.563-.377Z"
                                    transform="translate(-85.976 -79.543)"
                                    fill="#a4c2f7"
                                  />{" "}
                                  <g id="Group_521" data-name="Group 521">
                                    {" "}
                                    <path
                                      id="Path_193"
                                      data-name="Path 193"
                                      d="M11.1,22.2A11.1,11.1,0,1,1,22.2,11.1,11.1,11.1,0,0,1,11.1,22.2ZM11.1.807A10.292,10.292,0,1,0,21.391,11.1,10.292,10.292,0,0,0,11.1.807Z"
                                    />{" "}
                                    <path
                                      id="Path_194"
                                      data-name="Path 194"
                                      d="M95.127,93.442a11.109,11.109,0,0,1-7.147-2.61.4.4,0,0,1-.005-.613,3.256,3.256,0,0,1,.585-.415l3.191-1.741a.9.9,0,0,0,.469-.79V86.106a7.576,7.576,0,0,1-1.248-2.579,1.469,1.469,0,0,1-.541-1.139V80.958A1.47,1.47,0,0,1,90.788,80V78.118a3.255,3.255,0,0,1,.76-2.367,5.648,5.648,0,0,1,7.158,0,3.256,3.256,0,0,1,.76,2.367V80a1.47,1.47,0,0,1,.358.956v1.431a1.465,1.465,0,0,1-.841,1.327,8.232,8.232,0,0,1-1.056,2.068c-.086.122-.17.232-.249.33v1.193a.9.9,0,0,0,.5.8l3.417,1.709a3.242,3.242,0,0,1,.642.43.4.4,0,0,1,0,.618A11.11,11.11,0,0,1,95.127,93.442Zm-6.224-2.9a10.286,10.286,0,0,0,12.4.041l-.068-.035-3.417-1.709a1.7,1.7,0,0,1-.944-1.527V85.967a.4.4,0,0,1,.1-.266,4.842,4.842,0,0,0,.3-.383,7.459,7.459,0,0,0,1.007-2.031.4.4,0,0,1,.265-.262.674.674,0,0,0,.477-.636V80.958a.659.659,0,0,0-.225-.493.4.4,0,0,1-.133-.3V78.1a.392.392,0,0,1,0-.053,2.471,2.471,0,0,0-.57-1.768,4.908,4.908,0,0,0-5.937.008,2.432,2.432,0,0,0-.563,1.76.392.392,0,0,1,0,.053v2.069a.4.4,0,0,1-.133.3.659.659,0,0,0-.225.493v1.431a.668.668,0,0,0,.31.562.4.4,0,0,1,.174.249,6.741,6.741,0,0,0,1.211,2.509.407.407,0,0,1,.093.259v1.307a1.707,1.707,0,0,1-.89,1.5h0l-3.191,1.741Z"
                                      transform="translate(-84.027 -71.244)"
                                    />{" "}
                                  </g>{" "}
                                </svg>{" "}
                                <span>Profile</span>
                              </NavLink>
                            </li>
                          </ul>
                        </div>
                        <div className="box box-bottom-mobile navbar-mobile">
                          <h3 className="section-title1">Menu</h3>
                          <ul>
                            <li
                              className={
                                pathname.length == 1 ||
                                (pathname.includes("contest") &&
                                  !pathname.includes("profile"))
                                  ? "active"
                                  : ""
                              }
                            >
                              <NavLink to="/">
                                <svg
                                  className="showdefault"
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="55.49"
                                  height="47.525"
                                  viewBox="0 0 55.49 47.525"
                                >
                                  <path
                                    id="Forma_1"
                                    data-name="Forma 1"
                                    d="M30.7,46.025v-13.8H22.287v13.8H9.667a1.942,1.942,0,0,1-1.479-.683,2.313,2.313,0,0,1-.624-1.617V26.48a.5.5,0,0,1,.016-.108.545.545,0,0,0,.016-.107l18.9-17.031,18.9,17.031a.551.551,0,0,1,.033.215V43.725a2.312,2.312,0,0,1-.625,1.617,1.94,1.94,0,0,1-1.479.683ZM2.962,28.127a1.1,1.1,0,0,1-.691-.4L.233,25.073A1.234,1.234,0,0,1,0,24.228a1.076,1.076,0,0,1,.361-.772L24,1.935a3.8,3.8,0,0,1,4.994,0l8.02,7.329V2.258a1.177,1.177,0,0,1,.3-.826.979.979,0,0,1,.756-.324h6.311a.975.975,0,0,1,.755.324,1.173,1.173,0,0,1,.3.826V16.917l7.2,6.539a1.08,1.08,0,0,1,.362.772,1.234,1.234,0,0,1-.23.845l-2.038,2.659a1.1,1.1,0,0,1-.691.395h-.1a.962.962,0,0,1-.691-.251L26.495,7.144,3.75,27.876a1.182,1.182,0,0,1-.7.256Q3.006,28.131,2.962,28.127Z"
                                    transform="translate(1.25 0.25)"
                                    fill="none"
                                    stroke="#282828"
                                    strokeWidth="2.5"
                                  />
                                </svg>
                                <svg
                                  className="showclick"
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="52.99"
                                  height="45.025"
                                  viewBox="0 0 52.99 45.025"
                                >
                                  <path
                                    id="Forma_1"
                                    data-name="Forma 1"
                                    d="M30.7,46.025v-13.8H22.287v13.8H9.667a1.942,1.942,0,0,1-1.479-.683,2.313,2.313,0,0,1-.624-1.617V26.48a.5.5,0,0,1,.016-.108.545.545,0,0,0,.016-.107l18.9-17.031,18.9,17.031a.551.551,0,0,1,.033.215V43.725a2.312,2.312,0,0,1-.625,1.617,1.94,1.94,0,0,1-1.479.683ZM2.962,28.127a1.1,1.1,0,0,1-.691-.4L.233,25.073A1.234,1.234,0,0,1,0,24.228a1.076,1.076,0,0,1,.361-.772L24,1.935a3.8,3.8,0,0,1,4.994,0l8.02,7.329V2.258a1.177,1.177,0,0,1,.3-.826.979.979,0,0,1,.756-.324h6.311a.975.975,0,0,1,.755.324,1.173,1.173,0,0,1,.3.826V16.917l7.2,6.539a1.08,1.08,0,0,1,.362.772,1.234,1.234,0,0,1-.23.845l-2.038,2.659a1.1,1.1,0,0,1-.691.395h-.1a.962.962,0,0,1-.691-.251L26.495,7.144,3.75,27.876a1.182,1.182,0,0,1-.7.256Q3.006,28.131,2.962,28.127Z"
                                    transform="translate(0 -1)"
                                    fill="#262626"
                                  />
                                </svg>
                              </NavLink>
                            </li>
                            <li
                              className={
                                pathname.includes("explore") ? "active" : ""
                              }
                            >
                              <NavLink to="/explore">
                                <svg
                                  className="showdefault"
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="51.5"
                                  height="45.5"
                                  viewBox="0 0 51.5 45.5"
                                >
                                  <g
                                    id="Group_571"
                                    data-name="Group 571"
                                    transform="translate(2.25 -1.381)"
                                  >
                                    <line
                                      id="Line_89"
                                      data-name="Line 89"
                                      x2="48"
                                      transform="translate(-1 2.631)"
                                      fill="none"
                                      stroke="#282828"
                                      strokeLinecap="round"
                                      strokeWidth="2.5"
                                    />
                                    <line
                                      id="Line_90"
                                      data-name="Line 90"
                                      x2="48"
                                      transform="translate(0 45.631)"
                                      fill="none"
                                      stroke="#282828"
                                      strokeLinecap="round"
                                      strokeWidth="2.5"
                                    />
                                    <line
                                      id="Line_91"
                                      data-name="Line 91"
                                      x2="48"
                                      transform="translate(0 24.631)"
                                      fill="none"
                                      stroke="#282828"
                                      strokeLinecap="round"
                                      strokeWidth="2.5"
                                    />
                                  </g>
                                </svg>
                                <svg
                                  className="showclick"
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="55"
                                  height="49"
                                  viewBox="0 0 55 49"
                                >
                                  <g
                                    id="Group_571"
                                    data-name="Group 571"
                                    transform="translate(4 0.369)"
                                  >
                                    <line
                                      id="Line_89"
                                      data-name="Line 89"
                                      x2="48"
                                      transform="translate(-1 2.631)"
                                      fill="none"
                                      stroke="#282828"
                                      strokeLinecap="round"
                                      strokeWidth="6"
                                    />
                                    <line
                                      id="Line_90"
                                      data-name="Line 90"
                                      x2="48"
                                      transform="translate(0 45.631)"
                                      fill="none"
                                      stroke="#282828"
                                      strokeLinecap="round"
                                      strokeWidth="6"
                                    />
                                    <line
                                      id="Line_91"
                                      data-name="Line 91"
                                      x2="48"
                                      transform="translate(0 24.631)"
                                      fill="none"
                                      stroke="#282828"
                                      strokeLinecap="round"
                                      strokeWidth="6"
                                    />
                                  </g>
                                </svg>
                              </NavLink>
                            </li>
                            <li
                              className={
                                pathname.includes("profile") ? "active" : ""
                              }
                            >
                              <NavLink to="/profile">
                                <svg
                                  className="showdefault"
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="94.588"
                                  height="94.988"
                                  viewBox="0 0 94.588 94.988"
                                >
                                  <path
                                    id="Shape_4"
                                    data-name="Shape 4"
                                    d="M6.5,89.988A6.506,6.506,0,0,1,0,83.474,31.93,31.93,0,0,1,31.894,51.509h25.8A31.93,31.93,0,0,1,89.588,83.474a6.506,6.506,0,0,1-6.5,6.514ZM25.8,25.854V19.041a19,19,0,1,1,38,0v6.813a19,19,0,1,1-38,0Z"
                                    transform="translate(2.5 2.5)"
                                    fill="none"
                                    stroke="#282828"
                                    strokeWidth="5"
                                  />
                                </svg>
                                <svg
                                  className="showclick"
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="89.623"
                                  height="90.022"
                                  viewBox="0 0 89.623 90.022"
                                >
                                  <path
                                    id="Shape_4"
                                    data-name="Shape 4"
                                    d="M6.5,90.023A6.508,6.508,0,0,1,0,83.507,31.942,31.942,0,0,1,31.906,51.529H57.717A31.942,31.942,0,0,1,89.623,83.507a6.508,6.508,0,0,1-6.5,6.516Zm19.3-64.159V19.048a19.005,19.005,0,1,1,38.01,0v6.816a19.005,19.005,0,1,1-38.01,0Z"
                                    transform="translate(0 0)"
                                    fill="#282828"
                                  />
                                </svg>
                              </NavLink>
                            </li>
                          </ul>
                        </div>
                        <div className="box">
                          <ul>
                            <li
                              className={
                                pathname.includes("about") ? "active" : ""
                              }
                            >
                              <NavLink to="/about">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24.103"
                                  height="24.103"
                                  viewBox="0 0 24.103 24.103"
                                >
                                  {" "}
                                  <g
                                    id="Group_526"
                                    data-name="Group 526"
                                    transform="translate(0 0)"
                                  >
                                    {" "}
                                    <g
                                      id="Group_525"
                                      data-name="Group 525"
                                      transform="translate(0.471 0.471)"
                                    >
                                      {" "}
                                      <path
                                        id="Path_195"
                                        data-name="Path 195"
                                        d="M21.581,11.883a9.7,9.7,0,1,1-9.7,9.7A9.7,9.7,0,0,1,21.581,11.883Zm0,21.278A11.581,11.581,0,1,0,10,21.581,11.581,11.581,0,0,0,21.581,33.161Z"
                                        transform="translate(-10 -10)"
                                        fill="#8380e2"
                                      />{" "}
                                      <path
                                        id="Path_196"
                                        data-name="Path 196"
                                        d="M69.4,59.7A9.7,9.7,0,1,1,59.7,50,9.7,9.7,0,0,1,69.4,59.7Z"
                                        transform="translate(-48.117 -48.117)"
                                        fill="#b0e7f7"
                                      />{" "}
                                      <path
                                        id="Path_197"
                                        data-name="Path 197"
                                        d="M212.04,214.478a.942.942,0,1,1,0-1.883h.231v-4.707h-.231a.942.942,0,1,1,0-1.883h1.172a.941.941,0,0,1,.942.942v5.649h.231a.942.942,0,1,1,0,1.883Z"
                                        transform="translate(-201.631 -196.777)"
                                        fill="#8380e2"
                                      />{" "}
                                      <path
                                        id="Path_198"
                                        data-name="Path 198"
                                        d="M230.942,127.883a.942.942,0,1,0-.942-.942A.943.943,0,0,0,230.942,127.883Z"
                                        transform="translate(-219.643 -120.539)"
                                        fill="#8380e2"
                                      />{" "}
                                    </g>{" "}
                                    <path
                                      id="Path_199"
                                      data-name="Path 199"
                                      d="M20.573,3.53A12.052,12.052,0,0,0,5.028,2.258a.471.471,0,0,0,.549.765A11.108,11.108,0,1,1,3.022,5.578a.471.471,0,1,0-.765-.549A12.052,12.052,0,0,0,20.573,20.573a12.052,12.052,0,0,0,0-17.043Z"
                                    />{" "}
                                    <path
                                      id="Path_200"
                                      data-name="Path 200"
                                      d="M57.965,55.955a.471.471,0,0,0,.653-.129,10.166,10.166,0,1,0-2.791,2.792.471.471,0,1,0-.525-.782A9.226,9.226,0,1,1,57.836,55.3.471.471,0,0,0,57.965,55.955Z"
                                      transform="translate(-38.117 -38.117)"
                                    />{" "}
                                    <path
                                      id="Path_201"
                                      data-name="Path 201"
                                      d="M72.519,72.992a.471.471,0,1,0-.333-.8h0a.471.471,0,0,0,.333.8Z"
                                      transform="translate(-68.656 -68.659)"
                                    />{" "}
                                    <path
                                      id="Path_202"
                                      data-name="Path 202"
                                      d="M391.788,391.812h0a.471.471,0,1,0,.665-.032A.47.47,0,0,0,391.788,391.812Z"
                                      transform="translate(-373.227 -373.22)"
                                    />{" "}
                                    <path
                                      id="Path_203"
                                      data-name="Path 203"
                                      d="M201.1,204a1.414,1.414,0,0,0,1.412,1.412h2.345a1.412,1.412,0,0,0,.24-2.8v-5.2A1.414,1.414,0,0,0,203.683,196H202.51a1.412,1.412,0,0,0-.24,2.8v3.807A1.414,1.414,0,0,0,201.1,204Zm1.643-6.12h-.231a.471.471,0,0,1,0-.942h1.172a.471.471,0,0,1,.471.471v5.649a.471.471,0,0,0,.471.471h.231a.471.471,0,0,1,0,.942H202.51a.471.471,0,1,1,0-.942h.231a.471.471,0,0,0,.471-.471v-4.708A.471.471,0,0,0,202.741,197.883Z"
                                      transform="translate(-191.631 -186.773)"
                                    />{" "}
                                    <path
                                      id="Path_204"
                                      data-name="Path 204"
                                      d="M222.825,117.412a1.412,1.412,0,1,0-1.412,1.412A1.414,1.414,0,0,0,222.825,117.412Zm-1.883,0a.471.471,0,1,1,.471.471A.471.471,0,0,1,220.942,117.412Z"
                                      transform="translate(-209.643 -110.539)"
                                    />{" "}
                                  </g>{" "}
                                </svg>{" "}
                                About Contestee
                              </NavLink>
                            </li>
                            <li
                              className={
                                pathname.includes("how-it-works")
                                  ? "active"
                                  : ""
                              }
                            >
                              <NavLink to="/how-it-works">
                                <svg
                                  id="Group_1015"
                                  data-name="Group 1015"
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24.471"
                                  height="24.471"
                                  viewBox="0 0 24.471 24.471"
                                >
                                  {" "}
                                  <ellipse
                                    id="Ellipse_91"
                                    data-name="Ellipse 91"
                                    cx="11.828"
                                    cy="11.828"
                                    rx="11.828"
                                    ry="11.828"
                                    transform="translate(0.408 0.408)"
                                    fill="#f5fafc"
                                  />{" "}
                                  <path
                                    id="Path_518"
                                    data-name="Path 518"
                                    d="M89.086,81.425a8.568,8.568,0,0,0,.044-.86c0-.29-.015-.577-.043-.86l-1.348-.693q-.076-.353-.185-.693l.817-1.267a8.563,8.563,0,0,0-.865-1.493l-1.511.076q-.238-.262-.5-.5l.076-1.511a8.564,8.564,0,0,0-1.493-.866l-1.267.817q-.34-.109-.693-.185l-.693-1.348c-.283-.028-.57-.043-.861-.043a8.565,8.565,0,0,0-.86.044l-.693,1.348q-.353.076-.693.185l-1.267-.817a8.562,8.562,0,0,0-1.493.865l.076,1.511q-.262.238-.5.5l-1.511-.076a8.564,8.564,0,0,0-.866,1.493l.817,1.267q-.109.34-.185.693l-1.348.693c-.028.283-.043.57-.043.86s.015.577.043.86l1.348.693q.076.353.185.693l-.817,1.267a8.563,8.563,0,0,0,.865,1.493l1.511-.076q.238.262.5.5l-.076,1.511a8.564,8.564,0,0,0,1.493.866l1.267-.817q.34.109.693.185l.693,1.348c.283.028.57.043.861.043a8.567,8.567,0,0,0,.86-.044l.693-1.348q.353-.076.693-.185l1.267.817A8.538,8.538,0,0,0,85.57,87.5l-.076-1.511q.262-.238.5-.5l1.511.076a8.565,8.565,0,0,0,.866-1.493l-.817-1.267q.109-.34.185-.693Z"
                                    transform="translate(-68.329 -68.329)"
                                    fill="#ed4720"
                                  />{" "}
                                  <ellipse
                                    id="Ellipse_92"
                                    data-name="Ellipse 92"
                                    cx="5.71"
                                    cy="5.71"
                                    rx="5.71"
                                    ry="5.71"
                                    transform="translate(6.526 6.526)"
                                    fill="#55d5f2"
                                  />{" "}
                                  <path
                                    id="Path_519"
                                    data-name="Path 519"
                                    d="M67.627,78.576,67.56,79.9a.408.408,0,0,0,.169.351,8.988,8.988,0,0,0,1.564.907.406.406,0,0,0,.389-.029l1.108-.715c.117.034.235.066.355.095l.605,1.179a.408.408,0,0,0,.322.219c.3.03.6.045.9.045s.6-.015.9-.045a.408.408,0,0,0,.322-.219l.605-1.179c.12-.029.239-.06.355-.095l1.107.715a.408.408,0,0,0,.389.029,8.968,8.968,0,0,0,1.564-.907.408.408,0,0,0,.168-.351l-.066-1.322c.085-.082.17-.166.252-.252l1.322.066a.4.4,0,0,0,.351-.168,9.01,9.01,0,0,0,.907-1.564.408.408,0,0,0-.029-.389l-.715-1.107c.034-.116.066-.235.094-.355L81.68,74.2a.408.408,0,0,0,.219-.323,8.972,8.972,0,0,0,.046-.9c0-.3-.015-.6-.045-.9a.408.408,0,0,0-.219-.322L80.5,71.15c-.029-.12-.06-.238-.094-.355l.715-1.107a.407.407,0,0,0,.029-.389,8.938,8.938,0,0,0-.907-1.564.406.406,0,0,0-.351-.168l-1.321.066q-.124-.129-.252-.252l.066-1.321a.408.408,0,0,0-.169-.351,8.989,8.989,0,0,0-1.564-.907.41.41,0,0,0-.389.029l-1.108.715c-.117-.034-.235-.066-.355-.095L74.2,64.27a.408.408,0,0,0-.322-.219,9.048,9.048,0,0,0-1.8,0,.408.408,0,0,0-.322.219l-.605,1.179c-.12.029-.239.06-.355.095l-1.107-.715a.406.406,0,0,0-.389-.029,8.969,8.969,0,0,0-1.565.907.408.408,0,0,0-.168.351l.066,1.321q-.128.123-.252.252l-1.322-.066a.414.414,0,0,0-.351.168A9,9,0,0,0,64.8,69.3a.408.408,0,0,0,.029.389l.715,1.107c-.034.116-.066.235-.094.355l-1.179.605a.408.408,0,0,0-.219.323,8.838,8.838,0,0,0-.046.9c0,.3.015.6.045.9a.408.408,0,0,0,.219.322l1.179.606c.029.12.06.238.094.355l-.715,1.107a.408.408,0,0,0-.029.389,9.012,9.012,0,0,0,.907,1.564.411.411,0,0,0,.351.168l1.321-.066c.083.086.167.17.252.252Zm-1.3-3.132a.407.407,0,0,0,.046-.346,6.721,6.721,0,0,1-.175-.653.406.406,0,0,0-.212-.277l-1.148-.589c-.014-.2-.022-.4-.022-.6s.008-.4.022-.6l1.148-.589a.407.407,0,0,0,.212-.277,6.75,6.75,0,0,1,.175-.653.407.407,0,0,0-.046-.346l-.695-1.078a8.216,8.216,0,0,1,.6-1.043l1.286.065a.407.407,0,0,0,.322-.133c.151-.166.31-.325.473-.473a.407.407,0,0,0,.133-.323l-.065-1.286a8.115,8.115,0,0,1,1.043-.6l1.077.7a.405.405,0,0,0,.346.046c.21-.068.43-.126.654-.175a.407.407,0,0,0,.277-.212l.589-1.148a8.2,8.2,0,0,1,1.2,0l.589,1.148a.409.409,0,0,0,.277.212c.222.048.443.107.654.175a.407.407,0,0,0,.345-.046l1.078-.695a8.15,8.15,0,0,1,1.043.6L77.5,67.528a.409.409,0,0,0,.133.323c.163.148.322.308.472.472a.407.407,0,0,0,.322.133l1.286-.064a8.049,8.049,0,0,1,.6,1.043l-.695,1.078a.407.407,0,0,0-.046.346,6.717,6.717,0,0,1,.175.653.406.406,0,0,0,.212.277l1.148.589c.014.2.022.4.022.6s-.008.4-.022.6l-1.148.589a.407.407,0,0,0-.212.277,6.689,6.689,0,0,1-.175.653.407.407,0,0,0,.046.346l.695,1.078a8.245,8.245,0,0,1-.6,1.043L78.422,77.5a.394.394,0,0,0-.322.133c-.15.165-.31.324-.473.473a.407.407,0,0,0-.133.322l.064,1.286a8.162,8.162,0,0,1-1.043.6l-1.077-.7a.409.409,0,0,0-.346-.046c-.21.068-.43.126-.654.175a.407.407,0,0,0-.277.212l-.589,1.148a8.2,8.2,0,0,1-1.2,0l-.589-1.148a.409.409,0,0,0-.277-.212c-.222-.048-.443-.107-.654-.175a.405.405,0,0,0-.345.046l-1.078.695a8.152,8.152,0,0,1-1.043-.6l.065-1.286a.408.408,0,0,0-.133-.323c-.163-.148-.322-.308-.472-.472a.4.4,0,0,0-.322-.133l-1.286.064a8.089,8.089,0,0,1-.6-1.043Z"
                                    transform="translate(-60.737 -60.743)"
                                  />{" "}
                                  <path
                                    id="Path_520"
                                    data-name="Path 520"
                                    d="M126.118,132.235A6.118,6.118,0,1,0,120,126.118,6.125,6.125,0,0,0,126.118,132.235Zm0-11.42a5.3,5.3,0,1,1-5.3,5.3A5.308,5.308,0,0,1,126.118,120.816Z"
                                    transform="translate(-113.882 -113.882)"
                                  />{" "}
                                  <path
                                    id="Path_521"
                                    data-name="Path 521"
                                    d="M360,35.263h2.855a.428.428,0,0,0,.408-.408V32h-.816v2.447H360Z"
                                    transform="translate(-341.647 -30.369)"
                                  />{" "}
                                  <path
                                    id="Path_522"
                                    data-name="Path 522"
                                    d="M59.263,384H56.408a.428.428,0,0,0-.408.408v2.855h.816v-2.447h2.447Z"
                                    transform="translate(-53.145 -364.423)"
                                  />{" "}
                                  <path
                                    id="Path_523"
                                    data-name="Path 523"
                                    d="M.816,12.235A11.421,11.421,0,0,1,18.647,2.784l.229-.337.23-.338a12.237,12.237,0,0,0-17,17l.338-.23.337-.229A11.353,11.353,0,0,1,.816,12.235Z"
                                    transform="translate(0 0)"
                                  />{" "}
                                  <path
                                    id="Path_524"
                                    data-name="Path 524"
                                    d="M121.967,107.81l-.339.224a11.421,11.421,0,0,1-15.937,15.751l-.229.337-.23.338a12.237,12.237,0,0,0,17.076-16.877Z"
                                    transform="translate(-99.867 -102.099)"
                                  />{" "}
                                </svg>{" "}
                                How it works
                              </NavLink>
                            </li>
                            <li
                              className={
                                pathname.includes("FAQs") ? "active" : ""
                              }
                            >
                              <NavLink to="/FAQs">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="23.604"
                                  height="27.43"
                                  viewBox="0 0 23.604 27.43"
                                >
                                  {" "}
                                  <g
                                    id="Group_529"
                                    data-name="Group 529"
                                    transform="translate(0 0)"
                                  >
                                    {" "}
                                    <path
                                      id="Path_213"
                                      data-name="Path 213"
                                      d="M66.323,54.411A11.411,11.411,0,1,1,54.911,43,11.411,11.411,0,0,1,66.323,54.411Z"
                                      transform="translate(-43.098 -40.696)"
                                      fill="#ffc843"
                                    />{" "}
                                    <path
                                      id="Path_214"
                                      data-name="Path 214"
                                      d="M253.552,54.411a11.411,11.411,0,0,1-11.411,11.411q-.41,0-.813-.028a11.412,11.412,0,0,0,0-22.766q.4-.028.813-.028A11.411,11.411,0,0,1,253.552,54.411Z"
                                      transform="translate(-230.328 -40.696)"
                                      fill="#e79732"
                                    />{" "}
                                    <path
                                      id="Path_215"
                                      data-name="Path 215"
                                      d="M160.4,428.549a2.017,2.017,0,0,1-2.017-2.017v-.265a2.017,2.017,0,0,1,4.034,0v.265A2.017,2.017,0,0,1,160.4,428.549Z"
                                      transform="translate(-151.823 -401.521)"
                                      fill="#fff"
                                    />{" "}
                                    <path
                                      id="Path_216"
                                      data-name="Path 216"
                                      d="M122.807,14.523a3.354,3.354,0,0,1,3.334-2.989h.048A3.376,3.376,0,0,1,129.5,14.84a3.355,3.355,0,0,1-3.354,3.4h-.059a5.184,5.184,0,0,0-5.2,5.176v3.908a.536.536,0,0,0,.536.536h2.962a.536.536,0,0,0,.536-.536V23.447a1.151,1.151,0,0,1,1.16-1.171h.063a7.388,7.388,0,0,0,.1-14.775h-.106a7.388,7.388,0,0,0-7.378,7.023v1.238a.536.536,0,0,0,.536.536h2.973a.536.536,0,0,0,.536-.536Z"
                                      transform="translate(-114.328 -7.098)"
                                      fill="#fff"
                                    />{" "}
                                    <path
                                      id="Path_217"
                                      data-name="Path 217"
                                      d="M55.353,21.737a10.967,10.967,0,0,1-7.54,2.988c-.274,0-.549-.01-.822-.031a2.417,2.417,0,0,0-4.423-1.3A11.008,11.008,0,0,1,40.321,5.65a7.776,7.776,0,0,0-.288,1.755c0,.006,0,.013,0,.019V8.663a.939.939,0,0,0,.938.938h2.973a.939.939,0,0,0,.938-.937V7.447a2.952,2.952,0,0,1,2.932-2.609h.043a2.884,2.884,0,0,1,1.256.306.4.4,0,1,0,.359-.719,3.685,3.685,0,0,0-1.605-.391h-.052A3.756,3.756,0,0,0,44.08,7.382a.424.424,0,0,0,0,.043V8.663a.134.134,0,0,1-.134.134H40.97a.134.134,0,0,1-.134-.134V7.434A6.986,6.986,0,0,1,47.812.8h.1A6.986,6.986,0,0,1,52.788,12.7a6.934,6.934,0,0,1-4.972,2.081H47.75a1.552,1.552,0,0,0-1.561,1.573v3.879a.134.134,0,0,1-.134.134H43.092a.134.134,0,0,1-.134-.134V16.32a4.73,4.73,0,0,1,1.406-3.379,4.779,4.779,0,0,1,3.39-1.4h.059A3.746,3.746,0,0,0,50.94,5.722a.4.4,0,1,0-.669.446,2.946,2.946,0,0,1-2.456,4.574h-.061a5.586,5.586,0,0,0-5.6,5.578v3.908a.939.939,0,0,0,.938.938h2.962a.939.939,0,0,0,.938-.938V16.349a.749.749,0,0,1,.758-.769h.063A7.793,7.793,0,0,0,55.3,5.647a10.983,10.983,0,0,1,3.474,7.068.4.4,0,0,0,.4.366l.036,0a.4.4,0,0,0,.364-.436A11.8,11.8,0,0,0,54.671,4.1l0,0a7.851,7.851,0,0,0-1.352-1.808A7.743,7.743,0,0,0,47.924,0h-.112a7.8,7.8,0,0,0-6.86,4.1A11.8,11.8,0,0,0,36,13.715a11.806,11.806,0,0,0,6.235,10.414,2.411,2.411,0,0,0-.08.617v.265a2.419,2.419,0,0,0,4.789.485c.289.021.58.032.87.032a11.767,11.767,0,0,0,8.09-3.206.4.4,0,1,0-.55-.586Zm-9.165,3.275a1.615,1.615,0,0,1-3.23,0v-.265a1.615,1.615,0,0,1,3.23,0Z"
                                      transform="translate(-36 0)"
                                    />{" "}
                                    <path
                                      id="Path_218"
                                      data-name="Path 218"
                                      d="M419.747,261.829a.4.4,0,0,0-.426.376,10.934,10.934,0,0,1-2.308,6.083.4.4,0,0,0,.633.495,11.736,11.736,0,0,0,2.477-6.529A.4.4,0,0,0,419.747,261.829Z"
                                      transform="translate(-396.52 -247.801)"
                                    />{" "}
                                    <g
                                      id="Group_528"
                                      data-name="Group 528"
                                      transform="translate(12.388 16.623)"
                                    >
                                      {" "}
                                      <path
                                        id="Path_219"
                                        data-name="Path 219"
                                        d="M267.629,311.077h1.106a.4.4,0,1,0,0-.8h-1.106a.4.4,0,1,0,0,.8Z"
                                        transform="translate(-267.227 -310.273)"
                                        fill="#fff"
                                      />{" "}
                                      <path
                                        id="Path_220"
                                        data-name="Path 220"
                                        d="M271.433,337.93h-3.8a.4.4,0,1,0,0,.8h3.8a.4.4,0,1,0,0-.8Z"
                                        transform="translate(-267.227 -336.448)"
                                        fill="#fff"
                                      />{" "}
                                      <path
                                        id="Path_221"
                                        data-name="Path 221"
                                        d="M271.433,360.914h-3.8a.4.4,0,0,0,0,.8h3.8a.4.4,0,0,0,0-.8Z"
                                        transform="translate(-267.227 -358.201)"
                                        fill="#fff"
                                      />{" "}
                                    </g>{" "}
                                  </g>{" "}
                                </svg>{" "}
                                FAQs
                              </NavLink>
                            </li>
                            <li
                              className={
                                pathname.includes("analytics") ? "active" : ""
                              }
                            >
                              <NavLink to="/analytics">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="89.821"
                                  height="108.888"
                                  viewBox="0 0 89.821 108.888"
                                >
                                  {" "}
                                  <g
                                    id="Group_1368"
                                    data-name="Group 1368"
                                    transform="translate(457.482 27.5)"
                                  >
                                    {" "}
                                    <g
                                      id="Group_1366"
                                      data-name="Group 1366"
                                      transform="translate(-455.886 -25.905)"
                                    >
                                      {" "}
                                      <g id="Group_1363" data-name="Group 1363">
                                        {" "}
                                        <path
                                          id="Path_627"
                                          d="M-363.347 20.572v56.645a8.48 8.48 0 0 1-8.479 8.481H-441.5a8.483 8.483 0 0 1-8.247-6.5l-.034-4.849-.2-28.877v-56.991A8.48 8.48 0 0 1-441.5-20h37.579c3.377 0 14.315 9.326 23.983 19.147 8.822 8.964 16.588 18.341 16.588 21.425z"
                                          style={{ fill: "#ddeafb" }}
                                          data-name="Path 627"
                                          transform="translate(449.977 20)"
                                        />{" "}
                                        <path
                                          id="Path_628"
                                          d="M-146.895 91.455v20.678c-.638-25.461-21.378-26.639-28.16-33.421l11.574-8.681c8.822 8.964 16.588 18.341 16.588 21.425z"
                                          style={{ fill: "#cbe2ff" }}
                                          data-name="Path 628"
                                          transform="translate(233.525 -50.883)"
                                        />{" "}
                                        <path
                                          id="Path_629"
                                          d="M-310.232-20h-20.75.072c25.461.638 26.639 21.378 33.421 28.16l8.681-11.574C-297.771-12.233-307.148-20-310.232-20z"
                                          style={{ fill: "#cbe2ff" }}
                                          data-name="Path 629"
                                          transform="translate(356.289 20)"
                                        />{" "}
                                        <path
                                          id="Path_630"
                                          d="M-206.122 20.573v3.587A13.679 13.679 0 0 0-219.8 10.483h-8.325A8.482 8.482 0 0 1-236.6 2v-8.323A13.679 13.679 0 0 0-250.282-20h3.587a24.361 24.361 0 0 1 17.224 7.134l16.215 16.215a24.36 24.36 0 0 1 7.134 17.224z"
                                          style={{ fill: "#bed8fb" }}
                                          data-name="Path 630"
                                          transform="translate(292.752 20)"
                                        />{" "}
                                      </g>{" "}
                                      <g
                                        id="Group_1365"
                                        data-name="Group 1365"
                                        transform="translate(10.641 23.964)"
                                      >
                                        {" "}
                                        <g
                                          id="Group_1364"
                                          data-name="Group 1364"
                                        >
                                          {" "}
                                          <path
                                            id="Path_631"
                                            d="M-387.46 92.679h-8.561a3.923 3.923 0 0 0-3.923 3.923v48.977a3.923 3.923 0 0 0 3.923 3.923h8.561a3.923 3.923 0 0 0 3.923-3.923V96.6a3.923 3.923 0 0 0-3.923-3.923z"
                                            style={{ fill: "#78d0b1" }}
                                            data-name="Path 631"
                                            transform="translate(399.944 -92.679)"
                                          />{" "}
                                          <path
                                            id="Path_632"
                                            d="M-272.4 262.706h-8.561a3.923 3.923 0 0 0-3.923 3.923v12.817a3.923 3.923 0 0 0 3.923 3.923h8.561a3.923 3.923 0 0 0 3.923-3.923v-12.817a3.923 3.923 0 0 0-3.923-3.923z"
                                            style={{ fill: "#dd636e" }}
                                            data-name="Path 632"
                                            transform="translate(309.355 -226.546)"
                                          />{" "}
                                          <path
                                            id="Path_633"
                                            d="M-157.342 168.773h-8.558a3.923 3.923 0 0 0-3.923 3.923v32.794a3.923 3.923 0 0 0 3.923 3.923h8.561a3.923 3.923 0 0 0 3.923-3.923V172.7a3.923 3.923 0 0 0-3.923-3.923z"
                                            style={{ fill: "#f1d333" }}
                                            data-name="Path 633"
                                            transform="translate(218.766 -152.59)"
                                          />{" "}
                                        </g>{" "}
                                      </g>{" "}
                                    </g>{" "}
                                    <g
                                      id="Group_1367"
                                      data-name="Group 1367"
                                      transform="translate(-457.482 -27.5)"
                                    >
                                      {" "}
                                      <path
                                        id="Path_634"
                                        d="M-375.262-3.684L-391.477-19.9a25.783 25.783 0 0 0-18.352-7.6h-37.579a10.087 10.087 0 0 0-10.074 10.076v57l.219 31.947A9.9 9.9 0 0 0-450.8 80.8a10.051 10.051 0 0 0 3.388.584h69.672a10.086 10.086 0 0 0 10.074-10.074V14.668a25.784 25.784 0 0 0-7.6-18.352zm-18.471-13.959l16.215 16.215a22.656 22.656 0 0 1 5.573 9.087 15.228 15.228 0 0 0-10.988-4.676h-8.325a6.893 6.893 0 0 1-6.886-6.883v-8.325a15.228 15.228 0 0 0-4.676-10.989 22.655 22.655 0 0 1 9.087 5.571zm22.881 88.957a6.892 6.892 0 0 1-6.884 6.884h-69.672a6.864 6.864 0 0 1-2.315-.4 6.7 6.7 0 0 1-4.349-6.3l-.22-31.936v-56.986a6.893 6.893 0 0 1 6.884-6.886h33.992a12.1 12.1 0 0 1 12.082 12.082V-3.9a10.087 10.087 0 0 0 10.076 10.073h8.325a12.1 12.1 0 0 1 12.081 12.042v53.1z"
                                        data-name="Path 634"
                                        transform="translate(457.482 27.5)"
                                      />{" "}
                                      <path
                                        id="Path_635"
                                        d="M-148.507 383.15h-8.815a1.6 1.6 0 0 0-1.6 1.6 1.6 1.6 0 0 0 1.6 1.6h8.815a1.6 1.6 0 0 0 1.6-1.6 1.6 1.6 0 0 0-1.6-1.6z"
                                        data-name="Path 635"
                                        transform="translate(222.414 -295.816)"
                                      />{" "}
                                      <path
                                        id="Path_636"
                                        d="M-346.521 383.15h-42.041a1.6 1.6 0 0 0-1.6 1.6 1.6 1.6 0 0 0 1.6 1.6h42.041a1.6 1.6 0 0 0 1.6-1.6 1.6 1.6 0 0 0-1.6-1.6z"
                                        data-name="Path 636"
                                        transform="translate(404.475 -295.816)"
                                      />{" "}
                                      <path
                                        id="Path_637"
                                        d="M-367.255 423.041h-21.3a1.6 1.6 0 0 0-1.6 1.6 1.6 1.6 0 0 0 1.6 1.6h21.3a1.6 1.6 0 0 0 1.6-1.6 1.6 1.6 0 0 0-1.6-1.6z"
                                        data-name="Path 637"
                                        transform="translate(404.473 -327.223)"
                                      />{" "}
                                      <path
                                        id="Path_638"
                                        d="M-388.559 40.232h21.3a1.6 1.6 0 0 0 1.6-1.6 1.6 1.6 0 0 0-1.6-1.6h-21.3a1.6 1.6 0 0 0-1.6 1.6 1.6 1.6 0 0 0 1.6 1.6z"
                                        data-name="Path 638"
                                        transform="translate(404.473 -23.316)"
                                      />{" "}
                                      <path
                                        id="Path_639"
                                        d="M-393.368 145.194a5.525 5.525 0 0 0 5.519-5.519V90.7a5.525 5.525 0 0 0-5.519-5.519h-8.56a5.525 5.525 0 0 0-5.519 5.519v5.149a1.6 1.6 0 0 0 1.6 1.6 1.6 1.6 0 0 0 1.6-1.6V90.7a2.331 2.331 0 0 1 2.329-2.329h8.56a2.331 2.331 0 0 1 2.329 2.329v48.976a2.331 2.331 0 0 1-2.339 2.324h-8.56a2.331 2.331 0 0 1-2.329-2.329v-36.69a1.6 1.6 0 0 0-1.6-1.6 1.6 1.6 0 0 0-1.6 1.6v36.69a5.525 5.525 0 0 0 5.519 5.519z"
                                        data-name="Path 639"
                                        transform="translate(418.088 -61.216)"
                                      />{" "}
                                      <path
                                        id="Path_640"
                                        d="M-292.384 260.724v12.817a5.525 5.525 0 0 0 5.518 5.518h8.561a5.525 5.525 0 0 0 5.518-5.518v-12.817a5.525 5.525 0 0 0-5.518-5.518h-8.561a5.525 5.525 0 0 0-5.518 5.518zm3.19 0a2.331 2.331 0 0 1 2.328-2.328h8.561a2.331 2.331 0 0 1 2.328 2.328v12.817a2.331 2.331 0 0 1-2.328 2.328h-8.561a2.331 2.331 0 0 1-2.328-2.328z"
                                        data-name="Path 640"
                                        transform="translate(327.496 -195.082)"
                                      />{" "}
                                      <path
                                        id="Path_641"
                                        d="M-163.246 161.273h-8.561a5.525 5.525 0 0 0-5.518 5.518v32.794a5.525 5.525 0 0 0 5.518 5.518h8.561a5.525 5.525 0 0 0 5.518-5.518v-32.794a5.525 5.525 0 0 0-5.518-5.518zm2.328 38.312a2.331 2.331 0 0 1-2.328 2.328h-8.561a2.331 2.331 0 0 1-2.328-2.328v-32.794a2.331 2.331 0 0 1 2.328-2.328h8.561a2.331 2.331 0 0 1 2.328 2.328z"
                                        data-name="Path 641"
                                        transform="translate(236.907 -121.126)"
                                      />{" "}
                                    </g>{" "}
                                  </g>{" "}
                                </svg>{" "}
                                Analytics
                              </NavLink>
                            </li>
                            <li
                              className={
                                pathname.includes("settings") ? "active" : ""
                              }
                            >
                              <NavLink to="/settings">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="23.72"
                                  height="23.72"
                                  viewBox="0 0 23.72 23.72"
                                >
                                  {" "}
                                  <g
                                    id="Group_1016"
                                    data-name="Group 1016"
                                    transform="translate(0 0)"
                                  >
                                    {" "}
                                    <path
                                      id="Path_205"
                                      data-name="Path 205"
                                      d="M30.232,19.772V17.96a.077.077,0,0,0-.063-.075l-2.121-.372a.076.076,0,0,1-.062-.064,9.161,9.161,0,0,0-.512-1.916.076.076,0,0,1,.022-.086l1.649-1.382a.077.077,0,0,0,.017-.1L28.256,12.4a.077.077,0,0,0-.093-.034L26.14,13.1a.076.076,0,0,1-.085-.024,9.283,9.283,0,0,0-1.4-1.4.076.076,0,0,1-.024-.085l.738-2.024a.077.077,0,0,0-.034-.093l-1.569-.906a.077.077,0,0,0-.1.017l-1.382,1.649a.076.076,0,0,1-.086.022,9.161,9.161,0,0,0-1.916-.512.076.076,0,0,1-.063-.062l-.372-2.121a.077.077,0,0,0-.075-.063H17.961a.077.077,0,0,0-.075.063l-.372,2.121a.076.076,0,0,1-.064.062,9.161,9.161,0,0,0-1.916.512.076.076,0,0,1-.086-.022L14.066,8.588a.077.077,0,0,0-.1-.017L12.4,9.477a.077.077,0,0,0-.034.093l.738,2.024a.076.076,0,0,1-.024.085,9.283,9.283,0,0,0-1.4,1.4.076.076,0,0,1-.085.024L9.57,12.365a.077.077,0,0,0-.093.034l-.906,1.569a.077.077,0,0,0,.017.1l1.649,1.382a.076.076,0,0,1,.022.086,9.161,9.161,0,0,0-.512,1.916.076.076,0,0,1-.062.064l-2.121.372a.077.077,0,0,0-.063.075v1.812a.077.077,0,0,0,.063.075l2.121.372a.076.076,0,0,1,.062.064A9.161,9.161,0,0,0,10.26,22.2a.076.076,0,0,1-.022.086L8.589,23.667a.077.077,0,0,0-.017.1l.906,1.569a.077.077,0,0,0,.093.034l2.024-.738a.076.076,0,0,1,.085.024,9.283,9.283,0,0,0,1.4,1.4.076.076,0,0,1,.024.085l-.738,2.024a.077.077,0,0,0,.034.093l1.569.906a.077.077,0,0,0,.1-.017L15.448,27.5a.076.076,0,0,1,.086-.022,9.165,9.165,0,0,0,1.916.512.076.076,0,0,1,.064.062l.372,2.121a.077.077,0,0,0,.075.063h1.812a.077.077,0,0,0,.075-.063l.372-2.121a.076.076,0,0,1,.064-.062,9.161,9.161,0,0,0,1.916-.512.076.076,0,0,1,.086.022l1.382,1.649a.077.077,0,0,0,.1.017l1.569-.906a.077.077,0,0,0,.034-.093l-.738-2.024a.076.076,0,0,1,.024-.085,9.284,9.284,0,0,0,1.4-1.4.076.076,0,0,1,.085-.024l2.024.738a.077.077,0,0,0,.093-.034l.906-1.569a.077.077,0,0,0-.017-.1L27.5,22.285a.076.076,0,0,1-.022-.086,9.165,9.165,0,0,0,.512-1.916.076.076,0,0,1,.062-.064l2.121-.372a.077.077,0,0,0,.063-.076Z"
                                      transform="translate(-7.007 -7.006)"
                                      fill="#8eaadf"
                                    />{" "}
                                    <path
                                      id="Path_206"
                                      data-name="Path 206"
                                      d="M98.924,32.871,96.8,32.5a.076.076,0,0,1-.062-.063,9.161,9.161,0,0,0-.512-1.916.076.076,0,0,1,.022-.086L97.9,29.052a.077.077,0,0,0,.017-.1l-.906-1.569a.077.077,0,0,0-.093-.034L94.9,28.09a.076.076,0,0,1-.085-.024,9.282,9.282,0,0,0-1.4-1.4.076.076,0,0,1-.024-.085l.738-2.024a.077.077,0,0,0-.034-.093l-1.569-.906a.077.077,0,0,0-.1.017l-1.382,1.649a.076.076,0,0,1-.086.022,9.13,9.13,0,0,0-.912-.3A9.122,9.122,0,0,1,81.865,41.1a.073.073,0,0,1,0,.021l-.738,2.024a.077.077,0,0,0,.034.093l1.569.906a.077.077,0,0,0,.1-.017L84.2,42.482a.076.076,0,0,1,.086-.022,9.165,9.165,0,0,0,1.916.512.076.076,0,0,1,.064.062l.372,2.121a.077.077,0,0,0,.075.063h1.812a.077.077,0,0,0,.075-.063l.372-2.121a.076.076,0,0,1,.064-.062,9.161,9.161,0,0,0,1.916-.512.076.076,0,0,1,.086.022l1.382,1.649a.077.077,0,0,0,.1.017l1.569-.906a.077.077,0,0,0,.034-.093l-.738-2.024a.076.076,0,0,1,.024-.085,9.284,9.284,0,0,0,1.4-1.4.076.076,0,0,1,.085-.024l2.024.738a.077.077,0,0,0,.093-.034l.906-1.569a.077.077,0,0,0-.017-.1l-1.649-1.382a.076.076,0,0,1-.022-.086,9.161,9.161,0,0,0,.512-1.916.076.076,0,0,1,.062-.064l2.121-.372a.076.076,0,0,0,.063-.075V32.946a.077.077,0,0,0-.063-.075Z"
                                      transform="translate(-75.763 -21.993)"
                                      fill="#698ed5"
                                    />{" "}
                                    <ellipse
                                      id="Ellipse_55"
                                      data-name="Ellipse 55"
                                      cx="6.94"
                                      cy="6.94"
                                      rx="6.94"
                                      ry="6.94"
                                      transform="translate(4.92 4.92)"
                                      fill="#698ed5"
                                    />{" "}
                                    <path
                                      id="Path_207"
                                      data-name="Path 207"
                                      d="M119.824,77.751a6.942,6.942,0,0,1-6.06,12.135,6.94,6.94,0,1,0,6.06-12.135Z"
                                      transform="translate(-106.254 -72.619)"
                                      fill="#4073c8"
                                    />{" "}
                                    <ellipse
                                      id="Ellipse_56"
                                      data-name="Ellipse 56"
                                      cx="3.365"
                                      cy="3.365"
                                      rx="3.365"
                                      ry="3.365"
                                      transform="translate(8.495 8.495)"
                                      fill="#8eaadf"
                                    />{" "}
                                    <path
                                      id="Path_208"
                                      data-name="Path 208"
                                      d="M163.663,160.661v-1.278a.11.11,0,0,0-.055-.1l-1.107-.639a.11.11,0,0,0-.11,0l-1.107.639a.11.11,0,0,0-.055.1v1.278a.111.111,0,0,0,.055.1l1.107.639a.11.11,0,0,0,.11,0l1.107-.639a.11.11,0,0,0,.055-.1Z"
                                      transform="translate(-150.586 -148.162)"
                                      fill="#efecef"
                                    />{" "}
                                    <path
                                      id="Path_209"
                                      data-name="Path 209"
                                      d="M81.907,74.471a7.433,7.433,0,0,0-.347-2.251.5.5,0,1,0-.944.3,6.451,6.451,0,1,1-.99-1.918.5.5,0,0,0,.791-.6,7.435,7.435,0,1,0,1.49,4.465Z"
                                      transform="translate(-62.612 -62.611)"
                                    />{" "}
                                    <path
                                      id="Path_210"
                                      data-name="Path 210"
                                      d="M123.025,126.581a.5.5,0,1,0-.837.529,3.86,3.86,0,1,0-.563-2.564.5.5,0,1,0,.982.128,2.87,2.87,0,1,1,.418,1.907Z"
                                      transform="translate(-113.593 -113.19)"
                                    />{" "}
                                    <path
                                      id="Path_211"
                                      data-name="Path 211"
                                      d="M155.138,154.823a.607.607,0,0,0,.605,0l1.107-.639a.607.607,0,0,0,.3-.524v-1.278a.607.607,0,0,0-.3-.524l-1.107-.639a.607.607,0,0,0-.605,0l-1.107.639a.607.607,0,0,0-.3.524v1.278a.607.607,0,0,0,.3.524Zm-.419-2.219.722-.417.722.417v.834l-.722.417-.722-.417Z"
                                      transform="translate(-143.58 -141.161)"
                                    />{" "}
                                    <path
                                      id="Path_212"
                                      data-name="Path 212"
                                      d="M10.391,23.247a.571.571,0,0,0,.563.473h1.812a.571.571,0,0,0,.563-.473l.321-1.829a9.688,9.688,0,0,0,1.439-.384l1.192,1.423a.571.571,0,0,0,.724.128l1.569-.906a.571.571,0,0,0,.251-.691l-.637-1.747a9.791,9.791,0,0,0,1.052-1.052l1.747.637a.571.571,0,0,0,.691-.251l.906-1.569a.571.571,0,0,0-.128-.724l-1.423-1.192a9.69,9.69,0,0,0,.384-1.439l1.829-.321a.571.571,0,0,0,.473-.563V10.954a.571.571,0,0,0-.473-.563l-1.829-.321a9.694,9.694,0,0,0-.384-1.439l1.423-1.192a.571.571,0,0,0,.128-.724l-.906-1.569a.571.571,0,0,0-.691-.251l-1.747.637a9.8,9.8,0,0,0-1.052-1.052l.637-1.747a.571.571,0,0,0-.251-.691l-1.569-.906a.571.571,0,0,0-.724.128L15.089,2.687A9.688,9.688,0,0,0,13.65,2.3L13.329.473A.571.571,0,0,0,12.766,0H10.954a.571.571,0,0,0-.563.473L10.07,2.3a9.687,9.687,0,0,0-1.439.384L7.439,1.264a.571.571,0,0,0-.724-.128l-1.569.906a.571.571,0,0,0-.251.691l.637,1.747A9.8,9.8,0,0,0,4.479,5.531L2.733,4.894a.571.571,0,0,0-.691.251L1.136,6.715a.571.571,0,0,0,.128.724L2.686,8.631A9.69,9.69,0,0,0,2.3,10.07l-1.83.321A.571.571,0,0,0,0,10.954v1.812a.571.571,0,0,0,.473.563L2.3,13.65a9.691,9.691,0,0,0,.384,1.439L1.264,16.281a.571.571,0,0,0-.128.724l.906,1.569a.57.57,0,0,0,.691.252l1.747-.637A9.8,9.8,0,0,0,5.531,19.24l-.637,1.747a.571.571,0,0,0,.251.691l1.569.906a.571.571,0,0,0,.724-.128l1.192-1.423a9.691,9.691,0,0,0,1.439.384Zm-2.33-3.076-1.156,1.38L5.945,21,6.562,19.3a.571.571,0,0,0-.178-.64,8.8,8.8,0,0,1-1.327-1.327.571.571,0,0,0-.64-.178l-1.694.618-.555-.961,1.379-1.156a.571.571,0,0,0,.166-.644A8.687,8.687,0,0,1,3.23,13.2a.571.571,0,0,0-.466-.476L.99,12.415V11.305l1.774-.312a.571.571,0,0,0,.466-.476,8.693,8.693,0,0,1,.484-1.813.571.571,0,0,0-.166-.644L2.169,6.905l.555-.961,1.694.618a.571.571,0,0,0,.64-.178A8.8,8.8,0,0,1,6.384,5.058a.571.571,0,0,0,.178-.64L5.945,2.724l.961-.555,1.156,1.38a.571.571,0,0,0,.644.165,8.689,8.689,0,0,1,1.812-.484.571.571,0,0,0,.476-.466L11.305.99h1.109l.312,1.774a.571.571,0,0,0,.476.466,8.694,8.694,0,0,1,1.813.484.571.571,0,0,0,.644-.166l1.156-1.38.961.555-.618,1.693a.571.571,0,0,0,.178.64,8.807,8.807,0,0,1,1.327,1.327.572.572,0,0,0,.64.178L21,5.945l.555.961-1.38,1.156a.571.571,0,0,0-.165.644,8.685,8.685,0,0,1,.484,1.812.571.571,0,0,0,.466.476l1.774.312v1.109l-1.774.312a.571.571,0,0,0-.466.476,8.688,8.688,0,0,1-.484,1.813.571.571,0,0,0,.166.644l1.38,1.156L21,17.775,19.3,17.157a.571.571,0,0,0-.64.178,8.8,8.8,0,0,1-1.327,1.327.571.571,0,0,0-.178.64L17.775,21l-.961.555-1.156-1.38a.571.571,0,0,0-.644-.166,8.692,8.692,0,0,1-1.813.484.571.571,0,0,0-.476.466l-.312,1.774H11.305l-.312-1.774a.571.571,0,0,0-.476-.466,8.689,8.689,0,0,1-1.813-.484.571.571,0,0,0-.644.166Z"
                                    />{" "}
                                  </g>{" "}
                                </svg>{" "}
                                Settings
                              </NavLink>
                            </li>
                            <li
                              style={{ "text-transform": "capitalize" }}
                              className={
                                pathname.includes("feedback") ? "active" : ""
                              }
                            >
                              <NavLink to="/feedback">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  xlink="http://www.w3.org/1999/xlink"
                                  width="23.316"
                                  height="21.374"
                                  viewBox="0 0 23.316 21.374"
                                >
                                  {" "}
                                  <defs>
                                    {" "}
                                    <linearGradient
                                      id="linear-gradient"
                                      x1="-0.925"
                                      y1="-2.972"
                                      x2="-0.889"
                                      y2="-2.942"
                                      gradientUnits="objectBoundingBox"
                                    >
                                      {" "}
                                      <stop
                                        offset="0"
                                        stopOpacity="0.102"
                                      />{" "}
                                      <stop offset="1" stopOpacity="0" />{" "}
                                    </linearGradient>{" "}
                                  </defs>{" "}
                                  <g
                                    id="Group_531"
                                    data-name="Group 531"
                                    transform="translate(0 0)"
                                  >
                                    {" "}
                                    <path
                                      id="Path_222"
                                      data-name="Path 222"
                                      d="M19.431,21.333H1.943A1.945,1.945,0,0,0,0,23.276V42.221a.486.486,0,0,0,.3.449.48.48,0,0,0,.186.037.486.486,0,0,0,.343-.142l4.715-4.715H19.431a1.945,1.945,0,0,0,1.943-1.943V23.276A1.945,1.945,0,0,0,19.431,21.333Z"
                                      transform="translate(0 -21.333)"
                                    />{" "}
                                    <path
                                      id="Path_223"
                                      data-name="Path 223"
                                      d="M40.764,56.269a.973.973,0,0,1-.972.972H25.7a.485.485,0,0,0-.343.142l-4.029,4.029V43.639a.973.973,0,0,1,.972-.972H39.793a.973.973,0,0,1,.972.972Z"
                                      transform="translate(-20.361 -41.695)"
                                      fill="#15bef0"
                                    />{" "}
                                    <path
                                      id="Path_224"
                                      data-name="Path 224"
                                      d="M39.793,42.667v11.2a2.406,2.406,0,0,1-2.406,2.406H24.733a.486.486,0,0,0-.343.142l-1.683,1.683a4.691,4.691,0,0,0-1.374,3.317h0l4.029-4.029a.486.486,0,0,1,.343-.142H39.793a.972.972,0,0,0,.972-.972V43.639A.972.972,0,0,0,39.793,42.667Z"
                                      transform="translate(-20.361 -41.695)"
                                      opacity="0.1"
                                    />{" "}
                                    <g
                                      id="Group_530"
                                      data-name="Group 530"
                                      transform="translate(4.858 1.943)"
                                    >
                                      {" "}
                                      <path
                                        id="Path_225"
                                        data-name="Path 225"
                                        d="M117.839,128.972H107.152a.486.486,0,1,1,0-.972h10.687a.486.486,0,1,1,0,.972Z"
                                        transform="translate(-106.666 -125.085)"
                                      />{" "}
                                      <path
                                        id="Path_226"
                                        data-name="Path 226"
                                        d="M116.866,192.972h-9.715a.486.486,0,1,1,0-.972h9.715a.486.486,0,1,1,0,.972Z"
                                        transform="translate(-106.666 -186.171)"
                                      />{" "}
                                      <path
                                        id="Path_227"
                                        data-name="Path 227"
                                        d="M112.981,256.971h-5.829a.486.486,0,1,1,0-.972h5.829a.486.486,0,1,1,0,.972Z"
                                        transform="translate(-106.666 -247.255)"
                                      />{" "}
                                      <path
                                        id="Path_228"
                                        data-name="Path 228"
                                        d="M306.52,64a1.871,1.871,0,0,0-1.315.545l-5.913,5.912a.483.483,0,0,0-.133.248l-.486,2.43a.486.486,0,0,0,.476.581.5.5,0,0,0,.095-.009l2.428-.486a.483.483,0,0,0,.249-.133l4.858-4.857h0l1.055-1.055h0A1.859,1.859,0,0,0,306.52,64Z"
                                        transform="translate(-289.92 -64)"
                                      />{" "}
                                    </g>{" "}
                                    <path
                                      id="Path_229"
                                      data-name="Path 229"
                                      d="M324.507,127.412l-1.569.314.314-1.571,4.41-4.41L328.918,123Z"
                                      transform="translate(-308.231 -117.172)"
                                      fill="#fff"
                                    />{" "}
                                    <path
                                      id="Path_230"
                                      data-name="Path 230"
                                      d="M443.712,86.849l-.712.712L441.744,86.3l.712-.712a.888.888,0,0,1,1.256,1.257Z"
                                      transform="translate(-421.626 -82.418)"
                                      fill="#ffca28"
                                    />{" "}
                                    <path
                                      id="Path_231"
                                      data-name="Path 231"
                                      d="M304.907,189.284a.483.483,0,0,1-.249.133l-2.428.486a.5.5,0,0,1-.095.009.486.486,0,0,1-.343-.142l4.028,4.029h1.659a.972.972,0,0,0,.972-.972v-7.086Z"
                                      transform="translate(-288.048 -178.254)"
                                      fill="url(#linear-gradient)"
                                    />{" "}
                                  </g>{" "}
                                </svg>{" "}
                                Feedback
                              </NavLink>
                            </li>
                            <li
                              style={{ "text-transform": "capitalize" }}
                              className={
                                pathname.includes("invite-friends")
                                  ? "active"
                                  : ""
                              }
                            >
                              <NavLink to="/invite-friends">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="22.02"
                                  height="22.624"
                                  viewBox="0 0 22.02 22.624"
                                >
                                  {" "}
                                  <g
                                    id="Group_532"
                                    data-name="Group 532"
                                    transform="translate(0 0)"
                                  >
                                    {" "}
                                    <path
                                      id="Path_232"
                                      data-name="Path 232"
                                      d="M26.045,7.874a1.825,1.825,0,0,0-2.054,0l-8.975,6.111a1.547,1.547,0,0,0-.676,1.278V28.439a1.076,1.076,0,0,0,1.076,1.076h19.2A1.076,1.076,0,0,0,35.7,28.439V15.263a1.547,1.547,0,0,0-.676-1.278Z"
                                      transform="translate(-14.009 -7.223)"
                                      fill="#96c8ef"
                                    />{" "}
                                    <path
                                      id="Path_233"
                                      data-name="Path 233"
                                      d="M34.62,141.365a1.077,1.077,0,0,0,1.076-1.076V127.112a1.547,1.547,0,0,0-.676-1.279l-1.8-1.228-7.633,4.62a1.093,1.093,0,0,1-1.125,0l-7.6-4.651-1.845,1.256a1.547,1.547,0,0,0-.676,1.279v13.176a1.077,1.077,0,0,0,1.076,1.076Z"
                                      transform="translate(-14.009 -119.072)"
                                      fill="#78b9eb"
                                    />{" "}
                                    <path
                                      id="Path_234"
                                      data-name="Path 234"
                                      d="M91.791,81.415H75.873v-14.1A1.814,1.814,0,0,1,77.687,65.5H89.978a1.814,1.814,0,0,1,1.814,1.814v14.1Z"
                                      transform="translate(-72.823 -62.603)"
                                      fill="#fff5cc"
                                    />{" "}
                                    <path
                                      id="Path_235"
                                      data-name="Path 235"
                                      d="M84.4,131.841a1.093,1.093,0,0,1-1.125,0l-7.4-4.53V140.5H91.791V127.366Z"
                                      transform="translate(-72.823 -121.688)"
                                      fill="#ffeb99"
                                    />{" "}
                                    <path
                                      id="Path_236"
                                      data-name="Path 236"
                                      d="M23.083,168.5l-8.5-5.206a1.546,1.546,0,0,0-.238.824v13.176a1.076,1.076,0,0,0,1.076,1.076h19.2a1.076,1.076,0,0,0,1.076-1.076V164.114a1.546,1.546,0,0,0-.212-.781L26.954,168.5A3.744,3.744,0,0,1,23.083,168.5Z"
                                      transform="translate(-14.009 -156.075)"
                                      fill="#b9d8f4"
                                    />{" "}
                                    <path
                                      id="Path_237"
                                      data-name="Path 237"
                                      d="M33.289,282.2l-8.38,9.622a1.071,1.071,0,0,0,.6.184h19.2a1.071,1.071,0,0,0,.617-.195l-8.365-9.629A3.744,3.744,0,0,1,33.289,282.2Z"
                                      transform="translate(-24.111 -269.716)"
                                      fill="#d1e7f8"
                                    />{" "}
                                    <path
                                      id="Path_238"
                                      data-name="Path 238"
                                      d="M138.557,109.892H148.3a.331.331,0,1,0,0-.663h-9.745a.331.331,0,1,0,0,.663Z"
                                      transform="translate(-132.42 -104.403)"
                                    />{" "}
                                    <path
                                      id="Path_239"
                                      data-name="Path 239"
                                      d="M138.557,148.812H148.3a.331.331,0,1,0,0-.663h-9.745a.331.331,0,1,0,0,.663Z"
                                      transform="translate(-132.42 -141.603)"
                                    />{" "}
                                    <path
                                      id="Path_240"
                                      data-name="Path 240"
                                      d="M138.557,187.731h4.573a.331.331,0,0,0,0-.663h-4.573a.331.331,0,1,0,0,.663Z"
                                      transform="translate(-132.42 -178.802)"
                                    />{" "}
                                    <path
                                      id="Path_241"
                                      data-name="Path 241"
                                      d="M28.038,6.487l-1.9-1.292V4.708A2.147,2.147,0,0,0,24,2.563H22.274L19.063.376a2.144,2.144,0,0,0-2.427,0L13.428,2.561v0H11.7A2.147,2.147,0,0,0,9.559,4.708v.487l-1.9,1.292A1.877,1.877,0,0,0,6.84,8.039V21.216a1.3,1.3,0,0,0,1.408,1.408h19.2a1.409,1.409,0,0,0,1.408-1.408V8.039A1.876,1.876,0,0,0,28.038,6.487ZM28.2,8.039V21.216a.74.74,0,0,1-.117.4l-7.872-9.061,7.951-4.812A1.217,1.217,0,0,1,28.2,8.039ZM17.009.924a1.486,1.486,0,0,1,1.681,0L21.1,2.563H14.6Zm-5.3,2.3H24a1.484,1.484,0,0,1,1.482,1.482V7.215a.331.331,0,0,0,.663,0V6s1.637,1.122,1.687,1.17l-8.213,4.971a3.4,3.4,0,0,1-3.527,0L10.222,8.548V4.708A1.484,1.484,0,0,1,11.7,3.225ZM9.559,6V8.142l-1.65-1.01C7.949,7.1,9.559,6,9.559,6ZM8.208,21.959,9.383,20.61a.331.331,0,0,0-.5-.435l-1.26,1.447a.74.74,0,0,1-.121-.406V8.039a1.215,1.215,0,0,1,.051-.347l7.958,4.872L9.876,19.035a.331.331,0,0,0,.032.468.359.359,0,0,0,.468-.032L16.1,12.9a4.058,4.058,0,0,0,3.52-.01L27.5,21.959C27.485,21.96,8.222,21.96,8.208,21.959Z"
                                      transform="translate(-6.84 0)"
                                    />{" "}
                                  </g>{" "}
                                </svg>{" "}
                                Invite friends
                              </NavLink>{" "}
                            </li>
                            <li>
                              <a
                                href="https://www.instagram.com/contestee.official"
                                target="_blank"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  xlink="http://www.w3.org/1999/xlink"
                                  id="Group_1021"
                                  data-name="Group 1021"
                                  width="22.462"
                                  height="22.462"
                                  viewBox="0 0 22.462 22.462"
                                >
                                  {" "}
                                  <defs>
                                    {" "}
                                    <linearGradient
                                      id="linear-gradient"
                                      x1="0.072"
                                      y1="0.931"
                                      x2="0.933"
                                      y2="0.069"
                                      gradientUnits="objectBoundingBox"
                                    >
                                      {" "}
                                      <stop
                                        offset="0"
                                        stopColor="#5557cf"
                                      />{" "}
                                      <stop
                                        offset="0.497"
                                        stopColor="#d52b8c"
                                      />{" "}
                                      <stop offset="1" stopColor="#fed56c" />{" "}
                                    </linearGradient>{" "}
                                    <linearGradient
                                      id="linear-gradient-2"
                                      x1="-3.017"
                                      y1="8.238"
                                      x2="4.05"
                                      y2="1.171"
                                      href="#linear-gradient"
                                    />{" "}
                                    <linearGradient
                                      id="linear-gradient-3"
                                      x1="-0.555"
                                      y1="1.561"
                                      x2="1.565"
                                      y2="-0.559"
                                      href="#linear-gradient"
                                    />{" "}
                                  </defs>{" "}
                                  <g
                                    id="Group_881"
                                    data-name="Group 881"
                                    transform="translate(0.439 0.439)"
                                  >
                                    {" "}
                                    <path
                                      id="Path_525"
                                      data-name="Path 525"
                                      d="M15.264,11.755H26.32a3.52,3.52,0,0,1,3.51,3.51V26.32a3.52,3.52,0,0,1-3.51,3.51H15.264a3.52,3.52,0,0,1-3.51-3.51V15.264A3.52,3.52,0,0,1,15.264,11.755ZM26.32,10H15.264A5.28,5.28,0,0,0,10,15.264V26.32a5.28,5.28,0,0,0,5.264,5.264H26.32a5.28,5.28,0,0,0,5.264-5.264V15.264A5.28,5.28,0,0,0,26.32,10Z"
                                      transform="translate(-10 -10)"
                                      fill="url(#linear-gradient)"
                                    />{" "}
                                    <path
                                      id="Path_526"
                                      data-name="Path 526"
                                      d="M64.565,50H53.51A3.52,3.52,0,0,0,50,53.51V64.565a3.52,3.52,0,0,0,3.51,3.51H64.565a3.52,3.52,0,0,0,3.51-3.51V53.51A3.52,3.52,0,0,0,64.565,50Zm0,2.194a1.316,1.316,0,1,1-1.316,1.316A1.316,1.316,0,0,1,64.565,52.194ZM59.037,54.65a4.387,4.387,0,1,1-4.387,4.387A4.387,4.387,0,0,1,59.037,54.65Z"
                                      transform="translate(-48.245 -48.245)"
                                      fill="#fff"
                                    />{" "}
                                    <path
                                      id="Path_527"
                                      data-name="Path 527"
                                      d="M354.632,101.32A1.316,1.316,0,1,1,353.316,100,1.316,1.316,0,0,1,354.632,101.32Z"
                                      transform="translate(-336.996 -96.055)"
                                      fill="url(#linear-gradient-2)"
                                    />{" "}
                                    <path
                                      id="Path_528"
                                      data-name="Path 528"
                                      d="M164.774,160.387a4.387,4.387,0,1,0-4.387,4.387A4.387,4.387,0,0,0,164.774,160.387Zm-4.387-2.632a2.632,2.632,0,1,1-2.632,2.632A2.632,2.632,0,0,1,160.387,157.755Z"
                                      transform="translate(-149.595 -149.595)"
                                      fill="url(#linear-gradient-3)"
                                    />{" "}
                                    <path
                                      id="Path_529"
                                      data-name="Path 529"
                                      d="M201.264,198.632A2.632,2.632,0,1,1,198.632,196,2.632,2.632,0,0,1,201.264,198.632Z"
                                      transform="translate(-187.84 -187.84)"
                                      fill="#fff"
                                    />{" "}
                                  </g>{" "}
                                  <path
                                    id="Path_530"
                                    data-name="Path 530"
                                    d="M16.759,0H10.353a.439.439,0,0,0,0,.877h6.405A4.831,4.831,0,0,1,21.584,5.7V16.759a4.831,4.831,0,0,1-4.826,4.826H5.7A4.831,4.831,0,0,1,.877,16.759V5.7A4.831,4.831,0,0,1,5.7.877H6.844a.439.439,0,0,0,0-.877H5.7A5.71,5.71,0,0,0,0,5.7V16.759a5.71,5.71,0,0,0,5.7,5.7H16.759a5.71,5.71,0,0,0,5.7-5.7V5.7A5.71,5.71,0,0,0,16.759,0Z"
                                    transform="translate(0)"
                                  />{" "}
                                  <path
                                    id="Path_531"
                                    data-name="Path 531"
                                    d="M53.863,58.952H55A3.953,3.953,0,0,0,58.952,55V43.948A3.953,3.953,0,0,0,55,40H43.948A3.953,3.953,0,0,0,40,43.948V55a3.953,3.953,0,0,0,3.948,3.948h6.405a.439.439,0,1,0,0-.877H43.948A3.074,3.074,0,0,1,40.877,55V43.948a3.074,3.074,0,0,1,3.071-3.071H55a3.074,3.074,0,0,1,3.071,3.071V55A3.074,3.074,0,0,1,55,58.075H53.863a.439.439,0,1,0,0,.877Z"
                                    transform="translate(-38.245 -38.245)"
                                  />{" "}
                                  <path
                                    id="Path_532"
                                    data-name="Path 532"
                                    d="M155.652,150.826a4.826,4.826,0,1,0-4.826,4.826A4.831,4.831,0,0,0,155.652,150.826Zm-4.826,3.948a3.948,3.948,0,1,1,3.948-3.948A3.953,3.953,0,0,1,150.826,154.774Z"
                                    transform="translate(-139.595 -139.595)"
                                  />{" "}
                                  <path
                                    id="Path_533"
                                    data-name="Path 533"
                                    d="M189.071,186a3.071,3.071,0,1,0,3.071,3.071A3.074,3.074,0,0,0,189.071,186Zm0,5.264a2.194,2.194,0,1,1,2.194-2.194A2.2,2.2,0,0,1,189.071,191.264Z"
                                    transform="translate(-177.84 -177.84)"
                                  />{" "}
                                  <path
                                    id="Path_534"
                                    data-name="Path 534"
                                    d="M345.51,91.759a1.755,1.755,0,1,0-1.755,1.755A1.757,1.757,0,0,0,345.51,91.759Zm-2.632,0a.877.877,0,1,1,.877.877A.878.878,0,0,1,342.877,91.759Z"
                                    transform="translate(-326.996 -86.055)"
                                  />{" "}
                                  <path
                                    id="Path_535"
                                    data-name="Path 535"
                                    d="M186.439.877a.439.439,0,1,0,0-.877h0a.439.439,0,0,0,0,.877Z"
                                    transform="translate(-177.84)"
                                  />{" "}
                                  <path
                                    id="Path_536"
                                    data-name="Path 536"
                                    d="M306.439,452a.439.439,0,1,0,.439.439.439.439,0,0,0-.439-.439Z"
                                    transform="translate(-292.576 -432.17)"
                                  />{" "}
                                </svg>{" "}
                                Instagram page
                              </a>
                            </li>
                            <li
                              className={
                                pathname.includes("contact-us") ? "active" : ""
                              }
                            >
                              <NavLink to="/contact-us">
                                <svg
                                  id="Group_1020"
                                  data-name="Group 1020"
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="22.482"
                                  height="22.482"
                                  viewBox="0 0 22.482 22.482"
                                >
                                  {" "}
                                  <g id="Contact-3">
                                    {" "}
                                    <path
                                      id="Path_360"
                                      data-name="Path 360"
                                      d="M206.745,24c3.725,0,6.745,2.349,6.745,5.246s-3.02,5.246-6.745,5.246c-.12,0-.236-.007-.356-.015l-3.016,2.263.6-2.713C201.634,33.2,200,31.374,200,29.246,200,26.349,203.02,24,206.745,24Z"
                                      transform="translate(-191.382 -23.625)"
                                      fill="#00ccb3"
                                    />{" "}
                                    <path
                                      id="Path_361"
                                      data-name="Path 361"
                                      d="M29.246,388.433l2.623-2.623v-1.09l.967.262a2.253,2.253,0,0,1,1.656,2.17v2.406H24v-2.406a2.253,2.253,0,0,1,1.656-2.17l.967-.262v1.09Z"
                                      transform="translate(-23.625 -367.45)"
                                      fill="#5aaae7"
                                    />{" "}
                                    <path
                                      id="Path_362"
                                      data-name="Path 362"
                                      d="M85.246,380.32l-2.623,2.623L80,380.32v-1.09l.989-.27,1.634,1.36,1.634-1.36.989.27Z"
                                      transform="translate(-77.002 -361.96)"
                                      fill="#e6e7e8"
                                    />{" "}
                                    <path
                                      id="Path_363"
                                      data-name="Path 363"
                                      d="M104.387,356.465l-1.634,1.36-1.634-1.36.51-.139v-.967a3.016,3.016,0,0,0,2.248,0v.967Z"
                                      transform="translate(-97.133 -339.465)"
                                      fill="#ffb655"
                                    />{" "}
                                    <path
                                      id="Path_364"
                                      data-name="Path 364"
                                      d="M76.122,253.029A3,3,0,0,1,72,250.248V249.5h1.383a2.992,2.992,0,0,0,2.117-.877l.622-.622.127.255A2.243,2.243,0,0,0,78,249.484l0,.015v.749A3,3,0,0,1,76.122,253.029Z"
                                      transform="translate(-69.377 -237.133)"
                                      fill="#ffc477"
                                    />{" "}
                                    <path
                                      id="Path_365"
                                      data-name="Path 365"
                                      d="M70.745,187.389v1.124h-.109a2.023,2.023,0,0,1-.262-.015,2.243,2.243,0,0,1-1.75-1.229l-.127-.255-.622.622a2.992,2.992,0,0,1-2.117.877H64v-1.124a3.372,3.372,0,0,1,6.745,0Z"
                                      transform="translate(-61.752 -176.147)"
                                      fill="#8b5e3c"
                                    />{" "}
                                    <path
                                      id="Path_366"
                                      data-name="Path 366"
                                      d="M199.119,16C195.194,16,192,18.521,192,21.621a5.649,5.649,0,0,0,3.913,5.017l-.532,2.4a.375.375,0,0,0,.591.379l2.908-2.181c.079,0,.159.008.239.008,3.926,0,7.119-2.521,7.119-5.621S203.045,16,199.119,16Zm0,10.492c-.075,0-.15,0-.221-.008l-.12-.006a.389.389,0,0,0-.24.075l-2.206,1.654.384-1.726a.375.375,0,0,0-.242-.435c-2.263-.795-3.725-2.532-3.725-4.426,0-2.686,2.858-4.871,6.37-4.871s6.37,2.185,6.37,4.871-2.858,4.871-6.37,4.871Z"
                                      transform="translate(-183.756 -16)"
                                    />{" "}
                                    <path
                                      id="Path_367"
                                      data-name="Path 367"
                                      d="M256,128h8.244v.749H256Z"
                                      transform="translate(-244.759 -122.754)"
                                    />{" "}
                                    <path
                                      id="Path_368"
                                      data-name="Path 368"
                                      d="M256,96h8.244v.749H256Z"
                                      transform="translate(-244.759 -92.253)"
                                    />{" "}
                                    <path
                                      id="Path_369"
                                      data-name="Path 369"
                                      d="M256,160h8.244v.749H256Z"
                                      transform="translate(-244.759 -153.255)"
                                    />{" "}
                                    <path
                                      id="Path_370"
                                      data-name="Path 370"
                                      d="M25.309,185.677l-2.189-.6v-.444a3.372,3.372,0,0,0,1.874-3.016v-.375a.375.375,0,0,0,.375-.375v-1.124a3.747,3.747,0,1,0-7.494,0v1.124a.375.375,0,0,0,.375.375v.375a3.372,3.372,0,0,0,1.874,3.016v.444l-2.191.6A2.634,2.634,0,0,0,16,188.208v2.406a.375.375,0,0,0,.375.375H26.867a.375.375,0,0,0,.375-.375v-2.406A2.635,2.635,0,0,0,25.309,185.677Zm-5.936.385.525-.142,1.349,1.124v.947H22v-.948l1.349-1.124.525.142v.65l-2.248,2.248-2.248-2.248Zm-.749-6.315a3,3,0,0,1,6,0v.731a1.862,1.862,0,0,1-1.41-1.017l-.128-.256a.375.375,0,0,0-.6-.1l-.622.621A2.606,2.606,0,0,1,20,180.5H18.623ZM19,181.621v-.375H20a3.349,3.349,0,0,0,2.384-.988l.262-.262a2.6,2.6,0,0,0,1.593,1.17v.454a2.623,2.623,0,1,1-5.246,0Zm2.623,3.372a3.36,3.36,0,0,0,.749-.087v.462a.371.371,0,0,0,.131.278l-.88.733-.88-.733a.371.371,0,0,0,.131-.279v-.462A3.36,3.36,0,0,0,21.621,184.993Zm4.871,5.246H16.749v-2.031a1.883,1.883,0,0,1,1.38-1.808l.493-.133v.6a.375.375,0,0,0,.11.265l2.623,2.623a.375.375,0,0,0,.53,0l2.623-2.623a.375.375,0,0,0,.11-.265v-.6l.492.134a1.883,1.883,0,0,1,1.381,1.807Z"
                                      transform="translate(-16 -168.506)"
                                    />{" "}
                                    <path
                                      id="Path_371"
                                      data-name="Path 371"
                                      d="M107,304h-.749a.749.749,0,0,1-1.5,0H104a1.5,1.5,0,1,0,3,0Z"
                                      transform="translate(-99.878 -290.51)"
                                    />{" "}
                                  </g>{" "}
                                </svg>{" "}
                                Contact us
                              </NavLink>
                            </li>
                            <li
                              className={
                                pathname.includes("logout") ? "active" : ""
                              }
                            >
                              <a
                                onClick={() => {
                                  this.props.conformationModalOpen({
                                    message: "Are you sure you want to logout?",
                                    buttonText: "Yes",
                                    actionCall: [
                                      "showAppLoader",
                                      {
                                        actionName: "userLogout",
                                        params: {
                                          history: this.props.history
                                        }
                                      }
                                    ]
                                  });
                                }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="22.329"
                                  height="22.343"
                                  viewBox="0 0 22.329 22.343"
                                >
                                  {" "}
                                  <g
                                    id="Group_715"
                                    data-name="Group 715"
                                    transform="translate(0 0)"
                                  >
                                    {" "}
                                    <g
                                      id="Group_537"
                                      data-name="Group 537"
                                      transform="translate(0.382 0.399)"
                                    >
                                      {" "}
                                      <g
                                        id="Group_535"
                                        data-name="Group 535"
                                        transform="translate(5.949 1.484)"
                                      >
                                        {" "}
                                        <path
                                          id="Path_252"
                                          data-name="Path 252"
                                          d="M149.151,48.036v7.808a1.492,1.492,0,0,1-1.487,1.487h-6.693V38.741h6.693a1.492,1.492,0,0,1,1.487,1.487Z"
                                          transform="translate(-140.971 -38.741)"
                                          fill="#dce7ea"
                                        />{" "}
                                      </g>{" "}
                                      <g
                                        id="Group_536"
                                        data-name="Group 536"
                                        transform="translate(0 0)"
                                      >
                                        {" "}
                                        <path
                                          id="Path_253"
                                          data-name="Path 253"
                                          d="M10.386,6.175V25.138c0,.818-.595,1.3-1.3,1.041L5.552,24.766a1.342,1.342,0,0,1-1.115-1.487V7.663A1.372,1.372,0,0,1,5.552,6.175L9.085,4.762c.706-.26,1.3.223,1.3,1.041Z"
                                          transform="translate(-4.437 -4.692)"
                                          fill="#80d6fa"
                                        />{" "}
                                      </g>{" "}
                                    </g>{" "}
                                    <g id="Group_538" data-name="Group 538">
                                      {" "}
                                      <path
                                        id="Path_254"
                                        data-name="Path 254"
                                        d="M5.375,21.952a1.865,1.865,0,0,1-.446-.074L1.4,20.465A1.563,1.563,0,0,1,.17,18.792V3.175A1.563,1.563,0,0,1,1.4,1.5L4.929.089A1.038,1.038,0,0,1,5.97.2a1.3,1.3,0,0,1,.521,1.115V20.651a1.3,1.3,0,0,1-.521,1.115A1.029,1.029,0,0,1,5.375,21.952Zm0-21.565a1.085,1.085,0,0,0-.335.074L1.509,1.874c-.781.3-1,.595-1,1.3V18.792c0,.744.223,1.041,1,1.3l3.532,1.413a.775.775,0,0,0,.706-.037.941.941,0,0,0,.335-.818V1.316A.941.941,0,0,0,5.747.5.555.555,0,0,0,5.375.387ZM13,20.465H7.792a.186.186,0,0,1,0-.372H13a1.317,1.317,0,0,0,1.3-1.3V13.214a.186.186,0,1,1,.372,0v5.577A1.666,1.666,0,0,1,13,20.465ZM18.2,14.888a.224.224,0,0,1-.149-.037.18.18,0,0,1,0-.26l3.384-3.384H8.536a.186.186,0,0,1,0-.372H21.475L18.092,7.451a.184.184,0,0,1,.26-.26l3.718,3.718a.13.13,0,0,1,.037.074h0v.074h0v.074h0a.036.036,0,0,1-.037.037h0l-3.718,3.718C18.315,14.85,18.24,14.888,18.2,14.888Zm-13.385-2.6a.176.176,0,0,1-.186-.186V9.868a.186.186,0,0,1,.372,0V12.1A.176.176,0,0,1,4.818,12.285Zm9.667-3.346a.176.176,0,0,1-.186-.186V3.175a1.317,1.317,0,0,0-1.3-1.3H7.755a.176.176,0,0,1-.186-.186A.176.176,0,0,1,7.755,1.5H13a1.666,1.666,0,0,1,1.673,1.673V8.753A.176.176,0,0,1,14.485,8.939Z"
                                        transform="translate(0.026 0.195)"
                                      />{" "}
                                      <path
                                        id="Path_255"
                                        data-name="Path 255"
                                        d="M1.071,17.868a2.021,2.021,0,0,1-.494-.08L.553,17.78-2.98,16.367a1.75,1.75,0,0,1-1.35-1.855V-1.1A1.752,1.752,0,0,1-2.976-2.961L.553-4.373a1.241,1.241,0,0,1,1.227.133,1.489,1.489,0,0,1,.6,1.276V16.371a1.489,1.489,0,0,1-.6,1.276A1.227,1.227,0,0,1,1.071,17.868ZM.8-3.635-2.722-2.224c-.662.252-.881.449-.881,1.119V14.512c0,.663.171.882.87,1.115l.011,0L.814,17.046a.584.584,0,0,0,.524-.023.764.764,0,0,0,.244-.652V-2.964a.759.759,0,0,0-.247-.655l-.016-.011L1.3-3.643A.408.408,0,0,0,1.071-3.7.921.921,0,0,0,.8-3.635Zm1.061.08a1.5,1.5,0,0,1,.109.591V16.371a1.5,1.5,0,0,1-.108.59,1.35,1.35,0,0,0,.125-.591V-2.964A1.349,1.349,0,0,0,1.865-3.555ZM8.694,16.381H3.488a.382.382,0,1,1,0-.764H8.694A1.12,1.12,0,0,0,9.8,14.512V8.934a.382.382,0,1,1,.764,0v5.577A1.871,1.871,0,0,1,8.694,16.381Zm-5.212-.371Zm6.71-7.082Zm3.856,1.957L13.96,10.8a.308.308,0,0,1-.061.007.4.4,0,0,1-.287-.095.376.376,0,0,1,0-.538l3.049-3.049H4.232a.382.382,0,1,1,0-.764H16.7L13.649,3.31a.38.38,0,1,1,.538-.538L17.9,6.49A.319.319,0,0,1,18,6.7v.149a.231.231,0,0,1-.128.209Zm-.194-.476Zm3.733-3.658-3.65,3.65.046-.005,3.625-3.625v-.02ZM4.226,6.73ZM.514,8.2a.369.369,0,0,1-.382-.382V5.588a.369.369,0,0,1,.382-.382A.369.369,0,0,1,.9,5.588V7.819A.369.369,0,0,1,.514,8.2ZM.5,7.825Zm.021,0ZM.5,5.582Zm.021,0Zm9.657-.727A.369.369,0,0,1,9.8,4.473V-1.1A1.12,1.12,0,0,0,8.694-2.21H3.451a.369.369,0,0,1-.382-.382.369.369,0,0,1,.382-.382H8.694A1.871,1.871,0,0,1,10.563-1.1V4.472a.371.371,0,0,1-.382.382Zm-.011-.376ZM3.445-2.581Zm0-.021Z"
                                        transform="translate(4.33 4.475)"
                                      />{" "}
                                    </g>{" "}
                                  </g>{" "}
                                </svg>{" "}
                                Logout
                              </a>
                            </li>
                          </ul>
                        </div>
                        <div className="box advrtsmnt d-block d-lg-none">
                          <h3 className="section-title1">Advertisement</h3>
                          <span>1,750 viewers</span>
                          {/* <AdSense.Google
                                                        client='ca-pub-8111269642806838'
                                                        slot='1130655597'
                                                        style={{ display: 'block' }}
                                                        format='auto'
                                                        responsive='true'
                                                    // layoutKey='-gw-1+2a-9x+5c'
                                                    /> */}
                          <ins
                            className="adsbygoogle"
                            style={{ display: "block" }}
                            data-ad-client="ca-pub-8111269642806838"
                            data-ad-slot="1130655597"
                            data-ad-format="auto"
                            data-full-width-responsive="true"
                          ></ins>
                          {/* <img src={require('../img/advrtsmnt1.jpg')} /> */}
                        </div>
                        <div className="links d-block d-lg-none">
                          <ul>
                            <li>
                              <a>About Us</a> &nbsp;.&nbsp; <a>Support</a>{" "}
                              &nbsp;.&nbsp; <a>Press</a> &nbsp;.&nbsp;{" "}
                              <a>API</a> &nbsp;.&nbsp; <a>Jobs</a> &nbsp;.&nbsp;{" "}
                              <a>Privacy</a> &nbsp;.&nbsp; <a>Terms</a>{" "}
                              &nbsp;.&nbsp; <a>Directory</a> &nbsp;.&nbsp;{" "}
                              <a>Profiles</a> &nbsp;.&nbsp; <a>Hashtags</a>{" "}
                              &nbsp;.&nbsp; <a>Language</a>
                            </li>
                          </ul>
                          <p className="pb-3 mb-0">&copy; 2020 contestee</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-8 pl-0 pr-0 mhb">
                      {this.props.children}
                    </div>

                    <div className="col-lg-3 d-none d-lg-block pr-0">
                      <div className="sidebar" data-sticky_column>
                        <div className="box advrtsmnt">
                          <h3 className="section-title1">Advertisement</h3>
                          <span>1,750 viewers</span>
                          {/* <ins className="adsbygoogle"
                                                        style={{ display: 'block' }}
                                                        data-ad-client="ca-pub-8111269642806838"
                                                        data-ad-slot="1130655597"
                                                        data-ad-format="auto"
                                                        data-full-width-responsive="true"></ins> */}
                          <img src={require("../img/advrtsmnt1.jpg")} />
                        </div>
                        <div className="links">
                          <ul>
                            <li>
                              <a>About Us</a> &nbsp;.&nbsp; <a>Support</a>{" "}
                              &nbsp;.&nbsp; <a>Press</a> &nbsp;.&nbsp;{" "}
                              <a>API</a> &nbsp;.&nbsp; <a>Jobs</a> &nbsp;.&nbsp;{" "}
                              <a>Privacy</a> &nbsp;.&nbsp; <a>Terms</a>{" "}
                              &nbsp;.&nbsp; <a>Directory</a> &nbsp;.&nbsp;{" "}
                              <a>Profiles</a> &nbsp;.&nbsp; <a>Hashtags</a>{" "}
                              &nbsp;.&nbsp; <a>Language</a>
                            </li>
                          </ul>
                          <p>&copy; 2020 contestee</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <div
              className="modal"
              id="filtermodal"
              tabIndex="-1"
              role="dialog"
              aria-hidden="true"
            >
              <div className="modal-dialog modal-full" role="document">
                <div className="modal-content">
                  <div className="filter-modal">
                    <h5 className="text-center">
                      <a data-dismiss="modal">
                        <span className="icon fas fa-arrow-left"></span>
                      </a>{" "}
                      Filter
                    </h5>
                    <p>What kind of contests you are interested in</p>
                    {filterContestList.map((item, index) => (
                      <div
                        className="filterbox"
                        key={"filterContestList" + index}
                      >
                        <h4>{item.countryName}</h4>
                        <div className="filtermenu">
                          {item.contest.map((contest, index1) => (
                            <label
                              className="checkbox-styled"
                              key={`filterContestListitemcontest${index}${index1}`}
                            >
                              <input
                                type="checkbox"
                                name="checkbox"
                                value="checkbox"
                                checked={contest.isSelected}
                                onChange={() =>
                                  this.props.filterListData({
                                    category: item._id,
                                    categoryFlag: item.isSelected,
                                    contest: contest.name,
                                    contestFlag: contest.isSelected
                                  })
                                }
                              />
                              <span>{contest.name}</span>
                            </label>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({
  common,
  appLoader,
  modal,
  votingTicketModal,
  socialShareModal,
  conformationModal,
  user,
  reportModal,
  notification
}) => {
  const { redirectURL, filterContestList } = common;
  const { loader, label } = appLoader;
  const { open } = modal;
  const { open: voteOpen } = votingTicketModal;
  const { open: shareOpen } = socialShareModal;
  const { open: conformationOpen } = conformationModal;
  const { open: reportOpen } = reportModal;
  const { userData } = user;
  const { notifications, hasMore } = notification;
  return {
    redirectURL,
    filterContestList,
    loader,
    label,
    open,
    voteOpen,
    shareOpen,
    conformationOpen,
    userData,
    reportOpen,
    notifications,
    hasMore
  };
};

const mapDispatchToProps = dispatch => ({
  logOutRequest: () => dispatch(actions.logOutRequest()),
  changeRedirectURL: () => dispatch(actions.changeRedirectURL("")),
  getFilterListData: () => dispatch(actions.getFilterListData()),
  filterListData: payload => dispatch(actions.filterListData(payload)),
  getUser: () => dispatch(actions.getUser()),
  searchText: payload => dispatch(actions.searchText(payload)),
  getNotificationList: payload =>
    dispatch(actions.getNotificationList(payload)),
  conformationModalOpen: payload =>
    dispatch(actions.conformationModalOpen(payload)),
  notificationMarkAsRead: payload =>
    dispatch(actions.notificationMarkAsRead(payload)),
  modalClose: () => dispatch(actions.modalClose()),
  conformationModalClose: () => dispatch(actions.conformationModalClose()),
  profileMediaModalClose: () => dispatch(actions.profileMediaModalClose()),
  votingTicketModalClose: () => dispatch(actions.votingTicketModalClose()),
  socialShareModalClose: () => dispatch(actions.socialShareModalClose()),
  voterInfoModalClose: () => dispatch(actions.voterInfoModalClose()),
  reportModalClose: () => dispatch(actions.reportModalClose()),
  getUserContestProfileData: payload =>
    dispatch(actions.getUserContestProfileData(payload)),
  getEnrolledContests: () => dispatch(actions.getEnrolledContests()),
  resetContestProfile: () => dispatch(actions.resetContestProfile()),
  modalOpen: payload => dispatch(actions.modalOpen(payload))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Layout));
